import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  FileFolderCard,
  Labelbox,
  Button,
  Modal,
  FrameBox,
  MoveItemModal,
  MultiDocumentPreviewDock,
  DocuSignSendModal,
  DocuSignSignaturePanel,
  FiledCopiesUploadFileList,
} from "../../components";
import useDocumentPreviewPanes from "../../hooks/useDocumentPreviewPanes";
import { useDocumentTabUnread } from "../../hooks/useDocumentTabUnread";
import { useBusinessDocumentScope } from "../../hooks/useBusinessDocumentScope";
import { useClientCategoryTab } from "../../hooks/useClientCategoryTab";
import ClientBusinessSelector from "../../components/ClientBusinessSelector";
import DocumentTabBadge from "../../components/DocumentTabBadge";
import {
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  TextField,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EmailNotificationSwitch from "../../components/EmailNotificationSwitch";
import { useLocation } from "react-router-dom";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import { AddFolder, FileUpload } from "../../images";
import "./document.scss";
import {
  Toaster,
  dateTimeFormatter,
  getReadableFileType,
  getFileTypeIcon,
} from "../../utils/common";
import {
  openDocumentInNewTab,
  openDocumentPreviewTab,
} from "../../utils/openDocumentInNewTab";
import { useSelector, useDispatch } from "react-redux";
import { DOCUMENT_ACTION, CLIENT_ACTION } from "../../redux/action";
import { getClientById } from "../../redux/action/clientAction";
import Empty from "antd/es/empty";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Visibility,
  Edit,
  GetApp,
  Delete,
  ExpandMore,
  DriveFileMoveOutlined,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import UploadFilesHelpTooltip from "../../components/UploadFilesHelpTooltip";
import {
  DOCUMENT_UPLOAD_ACCEPT,
  DOCUMENT_UPLOAD_MAX_MB,
  DOCUMENT_UPLOAD_SIZE_NOTE,
  filterValidDocumentUploadFiles,
  hasInvalidDocumentUploadFiles,
} from "../../utils/documentUploadValidation";
import { fileBelongsToCurrentFolder } from "../../utils/documentFolderScope";
import {
  isSignableDocumentName,
  DOC_TAB_SENT_FOR_SIGNATURE,
  isDocumentsFolderTab,
} from "../../utils/docusignSignature";
import {
  normalizeDocumentCategoryFromNotification,
} from "../../utils/notificationNavigation";
import { showDocumentUnavailableMessage } from "../../utils/documentAvailability";
import { extractUserFilesList } from "../../utils/documentTabUnread";
import RequestedFilesBlock from "../../components/requestedFilesBlock";
import {
  DOCUMENTS_HOME_NAV,
  isDocumentsHomePath,
  resolveActiveTabFromFolderType,
  resolveFolderTypeFromNav,
} from "../../utils/documentTabSwitch";
import {
  DOC_TYPE_K1_PACKAGE,
  DOC_TYPE_FILED_COPIES,
  docTypeForFiledCopiesPurposeTab,
  getRootUploadFolderDropdownOptions,
  isInternalPurposeDocType,
  K1_PACKAGE_PURPOSE_TAB,
  FILED_COPIES_PURPOSE_TAB,
  K1_PACKAGE_TAB_LABEL,
  resolveDocumentModalContextTab,
  resolveStaffDocTypeFromPurpose,
  shouldIncludeDocumentCategoryInFetch,
  matchesPurposeTabFolder,
} from "../../utils/moveDocumentScope";
import {
  filterRecordsByClientCategory,
  recordMatchesClientCategory,
} from "../../utils/clientDetailsCategory";
import { clientHasBusinessAccess } from "../../utils/clientBusinessAccess";
import {
  appendBusinessIdToFormData,
  findBusinessBySelectionId,
  recordMatchesBusinessScope,
  withBusinessDocumentParams,
} from "../../utils/businessDocumentContext";
import {
  appendFiledCopiesTagsToFormData,
  appendFiledCopiesServiceToFormData,
  emptyTagsForFileCount,
  requiresFiledCopiesDocumentTag,
  shouldShowFiledCopiesTagPicker,
  validateFiledCopiesUpload,
  markFiledCopiesServiceCompleted,
} from "../../utils/filedCopiesUpload";
import { buildClientServiceDropdownOptions } from "../../constants/clientServiceOptions";

const normalizeDocClientType = (value) => {
  const s = String(value ?? "").trim().toLowerCase();
  if (s === "business" || s.startsWith("business")) return "business";
  if (s === "individual" || s.startsWith("individual")) return "individual";
  return s;
};

const getClientTypeFromRecord = (record) => {
  if (!record || typeof record !== "object") return "";
  return normalizeDocClientType(
    record.client_type ?? record.clientType ?? record.type,
  );
};

const readStoredClientProfile = () => {
  try {
    const raw = localStorage.getItem("USER_DATA");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const formatDocumentCreatedAt = (item) =>
  dateTimeFormatter(item?.createdAt || item?.created_at);

const UploadDoc = () => {
  const location = useLocation();
  const initialUserRole = localStorage.getItem("user_role");
  const [sendNotifications, setSendNotifications] = useState(true);
  const [notificationLevel] = useState(50);
  const [homeFolders, setHomeFolders] = useState([]);
  const [filetype, setFiletype] = useState("");
  const { userFiles, userFolders, allClientDocuments } = useSelector(
    (state) => state.document,
  );
  const clientData = useSelector((state) => state.client);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [renameFolderModalOpen, setRenameFolderModalOpen] = useState(false);
  const [moveModalOpen, setMoveModalOpen] = useState(false);
  const [moveItem, setMoveItem] = useState(null); // { type, data }
  const [signatureModal, setSignatureModal] = useState({
    open: false,
    document: null,
  });
  const [signatureRefreshKey, setSignatureRefreshKey] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [newName, setNewName] = useState("");
  // Default collapsed for non-client roles so we don't show stale downloaded docs before selecting a client
  const [isDownloadedOpen, setIsDownloadedOpen] = useState(
    initialUserRole === "client",
  );
  const [downloadedItems, setDownloadedItems] = useState([]);
  const [isDownloadedLoading, setIsDownloadedLoading] = useState(false);
  const [downloadedRefreshKey, setDownloadedRefreshKey] = useState(0);
  const clientDetails = location.state?.clientDetails;
  const suppressDownloadedOnEntryRef = useRef(false);
  const prevHomeUserIdRef = useRef(null);

  // upload files modal variables
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [filedCopiesFileTags, setFiledCopiesFileTags] = useState([]);
  const [filedCopiesServiceOptions, setFiledCopiesServiceOptions] = useState([]);
  const [filedCopiesSelectedServiceId, setFiledCopiesSelectedServiceId] =
    useState("");
  const [folderModalStage, setFolderModalStage] = useState("root");
  const [folderModalTitle, setFolderModalTitle] = useState("");
  const [folderModalPath, setFolderModalPath] = useState([]);
  const [folderModalScope, setFolderModalScope] = useState("root");
  const [pendingFolders, setPendingFolders] = useState([]);
  const [showUploadSubFolderInput, setShowUploadSubFolderInput] = useState(false);
  const [uploadSubFolderName, setUploadSubFolderName] = useState("");
  /** Tracks sent vs received when staff upload or add folders (drives doc_type / folder_type). */
  const documentModalContextTabRef = useRef("received");
  const pendingNavBusinessIdRef = useRef(null);

  const resolveStaffDocType = resolveStaffDocTypeFromPurpose;

  const setDocumentModalContextTab = (tab) => {
    documentModalContextTabRef.current = tab;
  };

  const syncDocumentModalContextTab = () => {
    setDocumentModalContextTab(resolveDocumentModalContextTab(activeTab, null));
  };


  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    const { validFiles, errors } = filterValidDocumentUploadFiles(files);
    errors.forEach((message) => Toaster.error(message));
    if (!validFiles.length) return;
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    setFileData((prevFiles) => [...prevFiles, ...validFiles]);
    if (shouldShowFiledCopiesTagPicker(getFiledCopiesTagPickerContext())) {
      setFiledCopiesFileTags((prevTags) => [
        ...prevTags,
        ...emptyTagsForFileCount(validFiles.length),
      ]);
    }
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFileData((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFiledCopiesFileTags((prevTags) => prevTags.filter((_, i) => i !== index));
  };

  const handleFiledCopiesTagChange = (index, value) => {
    setFiledCopiesFileTags((prevTags) => {
      const next = [...prevTags];
      next[index] = value;
      return next;
    });
  };

  const handleDragOver = (event) => event.preventDefault();

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files || []);
    const { validFiles, errors } = filterValidDocumentUploadFiles(files);
    errors.forEach((message) => Toaster.error(message));
    if (!validFiles.length) return;
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    setFileData((prevFiles) => [...prevFiles, ...validFiles]);
    if (shouldShowFiledCopiesTagPicker(getFiledCopiesTagPickerContext())) {
      setFiledCopiesFileTags((prevTags) => [
        ...prevTags,
        ...emptyTagsForFileCount(validFiles.length),
      ]);
    }
  };

  const dispatch = useDispatch();

  const getHomeFolderAndUserID = (type) => {
    if (type === "id") {
      return clientDetails?.client_id
        ? clientDetails?.client_id
        : localStorage.getItem("user_role") === "client" &&
            localStorage.getItem("user_id");
    }
    return clientDetails?.home_folder
      ? clientDetails?.home_folder
      : localStorage.getItem("user_role") === "client" &&
          localStorage.getItem("user_root_folder");
  };

  const [HOME_USER_ID, setHOME_USER_ID] = useState(
    getHomeFolderAndUserID("id"),
  );

  const getNavPath = () => {
    return clientDetails?.directory_details
      ? clientDetails?.client_document_id
        ? JSON.parse(clientDetails?.directory_details)
        : [
            ...JSON.parse(clientDetails?.directory_details),
            {
              id: clientDetails.client_folder_id,
              name: clientDetails.folder_name,
            },
          ]
      : [{ id: 0, name: "Home", created_by: 0 }];
  };

  const [HOME_FOLDER, setHOME_FOLDER] = useState(getHomeFolderAndUserID());

  const [navPath, setNavPath] = useState(getNavPath());
  const [currentIndex, setCurrentIndex] = useState(0);
  const isRootDocumentsFolder = navPath?.length === 1 && navPath[0]?.id === 0;
  const addFolderActionText = isRootDocumentsFolder
    ? "Upload Files"
    : "Add Sub Folder";
  const folderModalHeading = (() => {
    if (folderModalStage === "inner") return "Add Sub Folder";
    if (folderModalStage === "upload") return "Upload Files";
    if (folderModalStage === "menu") return "Upload Files Or Add Sub Folder";
    return "Add New Folder";
  })();
  const prevIndexRef = useRef(0);
  const documentOpenedRef = useRef(false);
  const searchInProgressRef = useRef(false);
  const documentUnavailableNotifiedRef = useRef(false);
  const notificationFolderReadyRef = useRef(false);

  const handleStaleClientDocumentNotification = () => {
    if (initialUserRole !== "client" || documentUnavailableNotifiedRef.current) {
      return;
    }
    documentUnavailableNotifiedRef.current = true;
    showDocumentUnavailableMessage();
    searchInProgressRef.current = false;
    documentOpenedRef.current = false;
    notificationFolderReadyRef.current = false;
    window.history.replaceState({}, document.title, window.location.pathname);
  };
  const pendingTabSwitchRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const {
    previews: documentPreviews,
    addPreview: addDocumentPreview,
    removePreview: removeDocumentPreview,
    closeAllPreviews: closeAllDocumentPreviews,
    hasPreviews: hasDocumentPreviews,
  } = useDocumentPreviewPanes();

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFiles([]);
    setFileData([]);
    setFiledCopiesFileTags([]);
    setFiledCopiesServiceOptions([]);
    setFiledCopiesSelectedServiceId("");
    setNewFolderName("");
    setFolderModalStage("root");
    setFolderModalTitle("");
    setFolderModalPath([]);
    setFolderModalScope("root");
    setPendingFolders([]);
    setShowUploadSubFolderInput(false);
    setUploadSubFolderName("");
    setSendNotifications(true);

    const isTourActive = localStorage.getItem("finlo_tour_completed") !== "true" && localStorage.getItem("finlo_tour_step") === "2";
    if (isTourActive) {
      localStorage.setItem("finlo_tour_step", "3");
      window.dispatchEvent(new CustomEvent("tour-step-change"));
    }
  };

  const openUploadSubFolderInput = () => {
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(true);
  };

  const cancelUploadSubFolderInput = () => {
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(false);
  };

  const addUploadSubFolder = () => {
    const folderName = uploadSubFolderName.trim();
    if (!folderName) {
      Toaster.warning("Please enter folder name");
      return;
    }

    let folder_type = "emp";
    if (pendingFolders.length > 0) {
      folder_type = pendingFolders[0].folder_type;
    } else if (isModalOpen === "client_upload") {
      folder_type = "client";
    } else if (isModalOpen === "office_upload") {
      folder_type = "office";
    } else if (isModalOpen === "k1_package_upload") {
      folder_type = DOC_TYPE_K1_PACKAGE;
    } else if (isModalOpen === "filed_copies_upload") {
      folder_type = DOC_TYPE_FILED_COPIES;
    } else if (isModalOpen.includes("upload")) {
      folder_type = isClient
        ? "emp"
        : resolveStaffDocType(documentModalContextTabRef.current);
    }

    setPendingFolders((prev) => [
      ...prev,
      {
        name: folderName,
        folder_type,
      },
    ]);

    setFolderModalTitle(folderName);
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(false);
  };

  const openInnerFolderModal = () => {
    setFolderModalStage("inner");
    setNewFolderName("");
    setModalOpen(
      folderModalScope === "root" ? "add_folder" : "inner_add_folder",
    );
  };

  const openFolderModalUpload = () => {
    setFolderModalStage("upload");
    setModalOpen(
      folderModalScope === "root"
        ? "root_add_folder_upload"
        : "inner_add_folder_upload",
    );
  };

  const getModalPath = () => {
    if (folderModalPath.length > 0) {
      return folderModalPath[folderModalPath.length - 1];
    }
    return getPath();
  };

  const buildKeyPathFromDirectoryDetails = (directoryDetails) => {
    const keyPathArr = [...directoryDetails];
    const writeRoot =
      activeDocCategory === "business" && documentHomeFolder
        ? documentHomeFolder
        : HOME_FOLDER;
    keyPathArr.splice(0, 1, { id: 0, name: writeRoot });
    return keyPathArr.map((segment) => segment.name).join("/");
  };

  const openPageAddFolder = () => {
    syncDocumentModalContextTab();
    const isRoot = navPath.length === 1 && navPath[0]?.id === 0;
    setFolderModalStage(isRoot ? "root" : "inner");
    setFolderModalScope(isRoot ? "root" : "inner");
    setNewFolderName("");
    setModalOpen(isRoot ? "root_add_folder" : "inner_add_folder");
  };

  const openStaffUploadModal = () => {
    syncDocumentModalContextTab();
    setModalOpen("emp_upload");
  };

  const [fileStructure, setFileStructure] = useState({
    folders: [],
    files: [],
  });

  const [activeTab, setActiveTab] = useState(() => {
    const isTourActive = localStorage.getItem("finlo_tour_completed") !== "true" && localStorage.getItem("finlo_tour_step") === "2";
    if (isTourActive) return "sent";
    return location.state?.documentsTab === "requested" ? "requested" : "received";
  }); // "sent" | "received" | "office" | "requested"

  const readDocCategoryFromLocation = (state) => {
    const raw = state?.documentCategory ?? state?.document_category;
    if (!raw) return null;
    return normalizeDocClientType(raw) === "business" ? "business" : "individual";
  };

  // Sub-category: separates Individual vs Business client documents.
  const [docCategory, setDocCategory] = useState(
    () => readDocCategoryFromLocation(location.state) || "individual",
  );
  const [viewedClientType, setViewedClientType] = useState(null);

  const isClientUser = initialUserRole === "client";
  const userRole = localStorage.getItem("user_role");
  const isClient = isClientUser || userRole === "client";
  const isEmployee = !isClient;
  const isAdmin = userRole === "admin";

  const getFiledCopiesTagPickerContext = () => ({
    modalId: isModalOpen,
    isClient,
    purposeTab: activeTab,
    folderModalContext: documentModalContextTabRef.current,
  });

  const showFiledCopiesTagPicker = shouldShowFiledCopiesTagPicker(
    getFiledCopiesTagPickerContext(),
  );

  useEffect(() => {
    if (!showFiledCopiesTagPicker) return;
    setFiledCopiesFileTags((prev) => {
      if (prev.length === fileData.length) return prev;
      if (fileData.length > prev.length) {
        return [...prev, ...emptyTagsForFileCount(fileData.length - prev.length)];
      }
      return prev.slice(0, fileData.length);
    });
  }, [showFiledCopiesTagPicker, fileData.length]);

  // Helper to determine if a file/folder is sent or received for current user
  const isSentItem = (item) => {
    if (!isClient) {
      // For admin/manager/employee: prefer doc_type/folder_type; fallback to created_by
      if (item.doc_type === "emp" || item.folder_type === "emp") return true;
      if (item.doc_type === "client" || item.folder_type === "client")
        return false;
      return item.created_by !== HOME_USER_ID;
    }

    // For client: trust doc_type/folder_type first; fallback to created_by when needed
    if (item.doc_type === "client" || item.folder_type === "client")
      return true;
    if (item.doc_type === "emp" || item.folder_type === "emp") return false;
    return item.created_by === HOME_USER_ID;
  };
  const isReceivedItem = (item) => !isSentItem(item);

  const folderMatchesActiveTab = (f) => {
    if (activeTab === "sent") return isSentItem(f);
    if (activeTab === "received") return isReceivedItem(f);
    if (activeTab === "office") return f.folder_type === "office";
    const filedCopiesDocType = docTypeForFiledCopiesPurposeTab(activeTab);
    if (filedCopiesDocType) return f.folder_type === filedCopiesDocType;
    return true;
  };

  const viewedClientProfile = useMemo(() => {
    if (clientDetails?.client_id) {
      return clientDetails;
    }
    if (!HOME_USER_ID || !clientData?.activeClients?.length) {
      return null;
    }
    return clientData.activeClients.find(
      (c) => String(c.client_id) === String(HOME_USER_ID),
    );
  }, [clientDetails, HOME_USER_ID, clientData?.activeClients]);

  const storedClientProfile = useMemo(() => {
    if (!isClientUser) return null;
    return readStoredClientProfile();
  }, [isClientUser, HOME_USER_ID]);

  const resolvedClientType =
    getClientTypeFromRecord(viewedClientProfile) ||
    getClientTypeFromRecord(storedClientProfile) ||
    normalizeDocClientType(viewedClientType);

  const isBusinessClient = clientHasBusinessAccess(
    viewedClientProfile || storedClientProfile,
  );
  const clientTypeResolved = Boolean(resolvedClientType);

  const {
    categoryTab: clientCategoryTab,
    setCategoryTab: setClientCategoryTab,
    showCategoryChooser,
    syncClientType,
  } = useClientCategoryTab();

  const activeDocCategory = showCategoryChooser ? clientCategoryTab : docCategory;

  const clientProfileForBusiness =
    viewedClientProfile || storedClientProfile || null;

  const {
    businesses: clientBusinesses,
    selectedClientBusinessId,
    setSelectedClientBusinessId,
    clientS3Root,
    documentHomeFolder,
    appendDocScope,
    showBusinessSelector,
    refreshBusinesses,
  } = useBusinessDocumentScope({
    clientId: HOME_USER_ID,
    clientRecord: clientProfileForBusiness,
    documentCategory: activeDocCategory,
  });

  useEffect(() => {
    if (activeDocCategory === "business" && HOME_USER_ID) {
      refreshBusinesses();
    }
  }, [activeDocCategory, HOME_USER_ID, refreshBusinesses]);

  const documentHomeForWrites = useMemo(() => {
    if (activeDocCategory === "business" && documentHomeFolder) {
      return documentHomeFolder;
    }
    return HOME_FOLDER;
  }, [activeDocCategory, documentHomeFolder, HOME_FOLDER]);

  useEffect(() => {
    if (activeDocCategory !== "business") return;
    setNavPath(DOCUMENTS_HOME_NAV);
    setCurrentIndex(0);
    setFiletype("home");
  }, [selectedClientBusinessId, activeDocCategory]);

  useEffect(() => {
    if (!HOME_USER_ID) {
      setViewedClientType(null);
      return;
    }

    const typeFromList = getClientTypeFromRecord(viewedClientProfile);
    if (typeFromList) {
      setViewedClientType(typeFromList);
      syncClientType(typeFromList);
      return;
    }

    const typeFromStorage = getClientTypeFromRecord(readStoredClientProfile());
    if (isClientUser && typeFromStorage) {
      setViewedClientType(typeFromStorage);
      syncClientType(typeFromStorage);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const client = await dispatch(getClientById(HOME_USER_ID)).unwrap();
        if (cancelled || !client) return;
        const type = getClientTypeFromRecord(client);
        if (type) {
          setViewedClientType(type);
          syncClientType(type);
          if (isClientUser) {
            try {
              const prev = readStoredClientProfile() || {};
              localStorage.setItem(
                "USER_DATA",
                JSON.stringify({ ...prev, ...client }),
              );
            } catch {
              /* ignore quota errors */
            }
          }
        }
      } catch (err) {
        console.error("Failed to load client profile for documents:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [HOME_USER_ID, viewedClientProfile, dispatch, isClientUser, syncClientType]);

  // Default document category for staff only (clients use session-persisted chooser).
  useEffect(() => {
    if (!HOME_USER_ID || !clientTypeResolved) return;
    const fromNavigation = readDocCategoryFromLocation(location.state);
    if (fromNavigation) {
      if (showCategoryChooser) {
        setClientCategoryTab(fromNavigation);
      } else {
        setDocCategory(fromNavigation);
      }
      return;
    }
    if (showCategoryChooser) return;
    setDocCategory(isBusinessClient ? "business" : "individual");
  }, [
    HOME_USER_ID,
    isBusinessClient,
    clientTypeResolved,
    location.key,
    location.state?.documentCategory,
    location.state?.document_category,
    showCategoryChooser,
    setClientCategoryTab,
  ]);

  useEffect(() => {
    if (location.state?.documentsTab === "requested") {
      setActiveTab("requested");
    }
    const fromNavigation = readDocCategoryFromLocation(location.state);
    if (fromNavigation) {
      if (showCategoryChooser) {
        setClientCategoryTab(fromNavigation);
      } else {
        setDocCategory(fromNavigation);
      }
    }
    const navBusinessId =
      location.state?.clientBusinessId ?? location.state?.client_business_id;
    if (
      fromNavigation === "business" &&
      navBusinessId != null &&
      String(navBusinessId).trim() !== ""
    ) {
      pendingNavBusinessIdRef.current = String(navBusinessId).trim();
    } else {
      pendingNavBusinessIdRef.current = null;
    }
  }, [location.key, location.state, showCategoryChooser, setClientCategoryTab]);

  useEffect(() => {
    const pending = pendingNavBusinessIdRef.current;
    if (!pending || activeDocCategory !== "business") return;
    if (!clientBusinesses.length) return;
    if (findBusinessBySelectionId(clientBusinesses, pending)) {
      setSelectedClientBusinessId(pending);
      pendingNavBusinessIdRef.current = null;
    }
  }, [
    activeDocCategory,
    clientBusinesses,
    setSelectedClientBusinessId,
    location.key,
  ]);

  // ---------- helpers for tabs ----------
  /** Received tab: only admin may delete; sent/office unchanged for staff. */
  const canDeleteDocument =
    !isClient && (activeTab !== "received" || isAdmin);

  // True when the category split is meaningful (client-shared documents).
  const isK1PackageTab = activeTab === K1_PACKAGE_PURPOSE_TAB;
  const isIndividualFiledCopiesTab = activeTab === FILED_COPIES_PURPOSE_TAB;
  const isFiledCopiesTab = isK1PackageTab || isIndividualFiledCopiesTab;
  const activeFiledCopiesDocType = isFiledCopiesTab
    ? docTypeForFiledCopiesPurposeTab(activeTab)
    : null;
  const documentTabClientId = isClient
    ? localStorage.getItem("user_id")
    : HOME_USER_ID;
  const {
    counts: documentTabUnread,
    getFolderUnreadCount,
    isFileHighlighted,
    clearFolderUnread,
    dismissFileHighlight,
    dismissFolderFileHighlights,
  } = useDocumentTabUnread({
    clientId: documentTabClientId,
    documentCategory: activeDocCategory,
    clientBusinessId:
      activeDocCategory === "business" ? selectedClientBusinessId : null,
    fileStructure,
  });
  const currentDocTab = activeTab;
  const getActiveTabLabel = (tab) => {
    switch (tab) {
      case "received":
        return isClient ? "Files from FinloTax" : "Client Uploads";
      case "sent":
        return isClient ? "My Uploads" : "FinloTax Uploads";
      case "office":
        return "Internal Files";
      case "requested":
        return isClient ? "Pending Files" : "Documents Requested";
      case DOC_TAB_SENT_FOR_SIGNATURE:
        return isClient ? "Files for Signature" : "Sent for Signature";
      case FILED_COPIES_PURPOSE_TAB:
      case K1_PACKAGE_PURPOSE_TAB:
        return K1_PACKAGE_TAB_LABEL;
      default:
        return "Home";
    }
  };
  const handleDocumentTabChange = (tab) => {
    if (tab === activeTab && isDocumentsHomePath(navPath)) {
      return;
    }
    navPath.slice(1).forEach((segment) => {
      if (segment?.id != null) {
        dismissFolderFileHighlights(segment.id, currentDocTab);
      }
    });
    pendingTabSwitchRef.current = tab;
    setNavPath(DOCUMENTS_HOME_NAV);
    setCurrentIndex(0);
    setFiletype("home");
    setActiveTab(tab);
  };
  const isCategoryAwareTab =
    activeTab === "sent" ||
    activeTab === "received" ||
    activeTab === "requested" ||
    activeTab === DOC_TAB_SENT_FOR_SIGNATURE ||
    isFiledCopiesTab;
  const docCategoryQueryValue = isCategoryAwareTab
      ? activeDocCategory
      : undefined;

  useEffect(() => {
    if (!showFiledCopiesTagPicker || !HOME_USER_ID) {
      setFiledCopiesServiceOptions([]);
      setFiledCopiesSelectedServiceId("");
      return undefined;
    }

    const serviceCategory = docCategoryQueryValue || activeDocCategory || "individual";
    let cancelled = false;
    (async () => {
      const data = await CLIENT_ACTION.getClientServices({
        client_id: HOME_USER_ID,
        status: "ongoing",
        service_category: serviceCategory,
      });
      if (cancelled) return;
      const list = filterRecordsByClientCategory(
        Array.isArray(data) ? data : [],
        serviceCategory,
      );
      setFiledCopiesServiceOptions(buildClientServiceDropdownOptions(list));
      setFiledCopiesSelectedServiceId("");
    })();

    return () => {
      cancelled = true;
    };
  }, [
    showFiledCopiesTagPicker,
    HOME_USER_ID,
    docCategoryQueryValue,
    activeDocCategory,
    isModalOpen,
  ]);

  const categoryFetchParams = useMemo(() => {
    const base = docCategoryQueryValue
      ? { document_category: docCategoryQueryValue }
      : {};
    return appendDocScope(base);
  }, [docCategoryQueryValue, appendDocScope]);

  const scopedToActiveCategory = (items) => {
    let list = docCategoryQueryValue
      ? filterRecordsByClientCategory(items, docCategoryQueryValue)
      : items || [];
    if (activeDocCategory === "business" && selectedClientBusinessId) {
      list = list.filter((item) =>
        recordMatchesBusinessScope(item, selectedClientBusinessId),
      );
    }
    return list;
  };

  useEffect(() => {
    setFileStructure({ folders: [], files: [] });
    setHomeFolders([]);
  }, [activeDocCategory]);

  const folderExists = useMemo(() => {
    if (!newFolderName) return false;
    const name = newFolderName.trim().toLowerCase();
    return (userFolders || []).some(
      (f) =>
        f.folder_name?.trim().toLowerCase() === name &&
        folderMatchesActiveTab(f) &&
        recordMatchesClientCategory(f, docCategoryQueryValue || "individual"),
    );
  }, [newFolderName, userFolders, activeTab, docCategoryQueryValue]);

  const rootUploadFolderOptions = useMemo(
    () => getRootUploadFolderDropdownOptions(activeDocCategory),
    [activeDocCategory],
  );

  const requestedFilesLayoutMode = useMemo(() => {
    if (!HOME_USER_ID) return "hidden";
    if (isClient) {
      return activeTab === "requested" ? "tableOnly" : "hidden";
    }
    return activeTab === "requested" ? "tableAndButton" : "hidden";
  }, [HOME_USER_ID, activeTab, isClient]);



  // ----- Downloaded section (API-driven, single endpoint) -----
  const buildFolderPathFromDirectoryDetails = (directoryDetails) => {
    if (!directoryDetails) return "Home";
    try {
      const arr =
        typeof directoryDetails === "string"
          ? JSON.parse(directoryDetails)
          : directoryDetails;
      const parts = (arr || [])
        .slice(1)
        .map((p) => p?.name)
        .filter(Boolean);
      return parts.length ? parts.join(" > ") : "Home";
    } catch (e) {
      return "Home";
    }
  };

  const getDocumentFolderPath = (doc) => {
    if (!doc) return "Home";
    if (doc.folder_path) return doc.folder_path;
    if (doc.directory_details)
      return buildFolderPathFromDirectoryDetails(doc.directory_details);
    if (doc.folder_name) return doc.folder_name;
    return "Home";
  };

  // Build full file URL path from document's folder structure
  const buildFileURLFromDocument = (doc) => {
    if (!doc) return null;

    // If document has directory_details, use it to build the full path
    if (doc.directory_details) {
      try {
        const arr =
          typeof doc.directory_details === "string"
            ? JSON.parse(doc.directory_details)
            : doc.directory_details;

        if (Array.isArray(arr) && arr.length > 0) {
          // Replace first item (Home) with actual HOME_FOLDER
          const pathArr = [...arr];
          pathArr[0] = { ...pathArr[0], name: documentHomeForWrites };
          const fullPath = pathArr
            .map((p) => p?.name)
            .filter(Boolean)
            .join("/");
          return `${fullPath}/${doc.document_name}`;
        }
      } catch (e) {
        console.error("Error parsing directory_details:", e);
      }
    }

    // Fallback: if we have folder_name, construct path
    if (doc.folder_name && doc.folder_name !== documentHomeForWrites) {
      return `${documentHomeForWrites}/${doc.folder_name}/${doc.document_name}`;
    }

    // Default: file is in root
    return `${documentHomeForWrites}/${doc.document_name}`;
  };

  useEffect(() => {
    // If we arrived from Client Details -> Documents page, reset/hide downloaded list
    if (location?.state?.fromClientDetails) {
      suppressDownloadedOnEntryRef.current = true;
      setDownloadedItems([]);
      setIsDownloadedOpen(false);
      setIsDownloadedLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.key]);

  // If no client is selected (non-client roles), never show downloaded docs
  useEffect(() => {
    if (initialUserRole !== "client" && !HOME_USER_ID) {
      suppressDownloadedOnEntryRef.current = true;
      setDownloadedItems([]);
      setIsDownloadedOpen(false);
      setIsDownloadedLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [HOME_USER_ID]);

  // When selecting/switching client (non-client roles), auto-open Downloaded section and refetch
  useEffect(() => {
    if (initialUserRole === "client") return;
    if (!HOME_USER_ID) return;

    const prev = prevHomeUserIdRef.current;
    const changed = prev !== null && String(prev) !== String(HOME_USER_ID);
    prevHomeUserIdRef.current = HOME_USER_ID;

    // Allow loading again once a client is selected
    suppressDownloadedOnEntryRef.current = false;
    setIsDownloadedOpen(true);
    setDownloadedItems([]);

    // Trigger API refresh (also handles switching between clients)
    setDownloadedRefreshKey((k) => k + 1);

    // If we switched clients, also clear any stale list immediately
    if (changed) {
      setDownloadedItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [HOME_USER_ID]);

  useEffect(() => {
    if (isClient) return;
    if (activeTab === "requested") return;
    if (!HOME_USER_ID) return;
    if (suppressDownloadedOnEntryRef.current) return;
    let cancelled = false;
    const run = async () => {
      // Only show loading if we don't have data yet or we're explicitly refreshing
      if (downloadedItems.length === 0 || downloadedRefreshKey > 0) {
        setIsDownloadedLoading(true);
      }
      try {
        await dispatch(
          DOCUMENT_ACTION.getAllClientDocuments({
            user_id: HOME_USER_ID,
            ...(docCategoryQueryValue
              ? categoryFetchParams
              : {}),
          }),
        );
      } finally {
        if (!cancelled) setIsDownloadedLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [HOME_USER_ID, downloadedRefreshKey, activeTab, docCategoryQueryValue, selectedClientBusinessId]);

  useEffect(() => {
    if (isClient) {
      setDownloadedItems([]);
      return;
    }
    if (activeTab === "requested") {
      setDownloadedItems([]);
      return;
    }
    if (!isDownloadedOpen) {
      // Avoid showing stale downloaded list when section is closed
      setDownloadedItems([]);
      return;
    }
    if (!HOME_USER_ID) {
      setDownloadedItems([]);
      return;
    }
    const all = Array.isArray(allClientDocuments) ? allClientDocuments : [];

    // Get current folder ID from navPath
    const currentFolderId = navPath[navPath.length - 1]?.id;

    const downloaded = all
      .filter((d) => Number(d.downloaded) === 1)
      .filter((d) => recordMatchesBusinessScope(d, selectedClientBusinessId))
      // Filter by current folder: only show documents from the folder we're currently viewing
      .filter((d) => {
        // Compare folder IDs - documents should belong to current folder
        const docFolderId = d.client_folder_id;
        return docFolderId === currentFolderId;
      })
      .map((d) => ({ ...d, __folderPath: getDocumentFolderPath(d) }));

    let filtered = [];
    if (activeTab === "sent") {
      // For clients: show doc_type === "client" (what they sent)
      // For employees: show doc_type === "emp" (what they sent)
      const sentDocType = isClient ? "client" : "emp";
      filtered = downloaded.filter((d) => d.doc_type === sentDocType);
    } else if (activeTab === "received") {
      // For clients: show doc_type === "emp" (what they received from employees)
      // For employees: show doc_type === "client" (what they received from clients)
      const receivedDocType = isClient ? "emp" : "client";
      filtered = downloaded.filter((d) => d.doc_type === receivedDocType);
    } else if (activeTab === "office") {
      // Office tab only for employees: show doc_type === "office"
      filtered = downloaded.filter((d) => d.doc_type === "office");
    } else if (isFiledCopiesTab) {
      filtered = downloaded.filter(
        (d) => d.doc_type === activeFiledCopiesDocType,
      );
    }

    if (docCategoryQueryValue) {
      filtered = filterRecordsByClientCategory(filtered, docCategoryQueryValue);
    }

    const byId = new Map();
    for (const d of filtered) {
      const key =
        d.client_document_id || `${d.document_name}-${d.__folderPath}`;
      byId.set(key, d);
    }
    const finalList = Array.from(byId.values()).sort((a, b) => {
      const da = new Date(a.updatedAt || a.createdAt || 0).getTime();
      const db = new Date(b.updatedAt || b.createdAt || 0).getTime();
      return db - da;
    });
    setDownloadedItems(finalList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allClientDocuments, activeTab, HOME_USER_ID, isDownloadedOpen, navPath, docCategoryQueryValue]);

  useMemo(() => {
    setNavPath(getNavPath());
  }, [clientDetails]);

  // Recursive function to search for a folder in all levels
  const searchFolderRecursively = async (
    targetFolderId,
    searchUserId,
    searchHomeFolder,
    currentPath = [{ id: 0, name: "Home", created_by: 0 }],
    visitedFolders = new Set(),
    documentCategory,
  ) => {
    const categoryParams = documentCategory
      ? { document_category: documentCategory }
      : {};
    const currentFolderId = currentPath[currentPath.length - 1].id;
    const currentFolderName =
      currentPath[currentPath.length - 1].name === "Home"
        ? searchHomeFolder
        : currentPath[currentPath.length - 1].name;

    // Prevent infinite loops
    const visitKey = `${searchUserId}-${currentFolderId}`;
    if (visitedFolders.has(visitKey)) {
      return null;
    }
    visitedFolders.add(visitKey);

    try {
      // Load folders for current path
      const folderResponse = await dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: searchUserId,
          folder_name: currentFolderName,
          folder_id: currentFolderId,
          ...categoryParams,
        }),
      );

      const folders = folderResponse.payload || [];

      // Check if target folder is in current level
      const foundFolder = folders.find(
        (f) => String(f.client_folder_id) === String(targetFolderId),
      );
      if (foundFolder) {
        // Build path to this folder
        let folderNavPath = [...currentPath];

        if (foundFolder.directory_details) {
          try {
            folderNavPath = JSON.parse(foundFolder.directory_details);
          } catch (e) {
            folderNavPath.push({
              id: foundFolder.client_folder_id,
              name: foundFolder.folder_name,
              created_by: foundFolder.created_by || 0,
            });
          }
        } else {
          folderNavPath.push({
            id: foundFolder.client_folder_id,
            name: foundFolder.folder_name,
            created_by: foundFolder.created_by || 0,
          });
        }

        return { folderNavPath, clientId: searchUserId };
      }

      // Search in subfolders
      for (const folder of folders) {
        const subPath = [
          ...currentPath,
          {
            id: folder.client_folder_id,
            name: folder.folder_name,
            created_by: folder.created_by || 0,
          },
        ];

        const result = await searchFolderRecursively(
          targetFolderId,
          searchUserId,
          searchHomeFolder,
          subPath,
          visitedFolders,
          documentCategory,
        );
        if (result) {
          return result;
        }
      }
    } catch (error) {
      console.error("Error searching folder:", error);
    }

    return null;
  };

  // Recursive function to search for a document in all folders
  const searchDocumentRecursively = async (
    targetDocumentId,
    searchUserId,
    searchHomeFolder,
    currentPath = [{ id: 0, name: "Home", created_by: 0 }],
    visitedFolders = new Set(),
    documentCategory,
  ) => {
    const categoryParams = documentCategory
      ? { document_category: documentCategory }
      : {};
    const currentFolderId = currentPath[currentPath.length - 1].id;
    const currentFolderName =
      currentPath[currentPath.length - 1].name === "Home"
        ? searchHomeFolder
        : currentPath[currentPath.length - 1].name;

    // Prevent infinite loops
    const visitKey = `${searchUserId}-${currentFolderId}`;
    if (visitedFolders.has(visitKey)) {
      return null;
    }
    visitedFolders.add(visitKey);

    try {
      // Load files for current path
      const fileResponse = await dispatch(
        DOCUMENT_ACTION.getUserFiles({
          user_id: searchUserId,
          folder_name: currentFolderName,
          folder_id: currentFolderId,
          ...categoryParams,
        }),
      );

      const files = extractUserFilesList(fileResponse.payload);

      // Check if target document is in current level
      const foundDocument = files.find(
        (f) => String(f.client_document_id) === String(targetDocumentId),
      );
      if (foundDocument) {
        // Return the path to this document's folder
        return { folderNavPath: currentPath, clientId: searchUserId };
      }

      // Load folders to search in subfolders
      const folderResponse = await dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: searchUserId,
          folder_name: currentFolderName,
          folder_id: currentFolderId,
          ...categoryParams,
        }),
      );

      const folders = folderResponse.payload || [];

      // Search in subfolders
      for (const folder of folders) {
        const subPath = [
          ...currentPath,
          {
            id: folder.client_folder_id,
            name: folder.folder_name,
            created_by: folder.created_by || 0,
          },
        ];

        const result = await searchDocumentRecursively(
          targetDocumentId,
          searchUserId,
          searchHomeFolder,
          subPath,
          visitedFolders,
          documentCategory,
        );
        if (result) {
          return result;
        }
      }
    } catch (error) {
      console.error("Error searching document:", error);
    }

    return null;
  };

  // Handle navigation from notifications - select client and open folder/document
  useEffect(() => {
    // Only run once when notification state is set and clients are loaded
    if (
      location.state?.fromNotification &&
      !searchInProgressRef.current &&
      clientData?.activeClients &&
      clientData.activeClients.length > 0
    ) {
      const performSearch = async () => {
        searchInProgressRef.current = true;

        const notificationCategory = normalizeDocumentCategoryFromNotification(
          location.state,
        );
        if (showCategoryChooser) {
          setClientCategoryTab(notificationCategory);
        } else {
          setDocCategory(notificationCategory);
        }

        const documentsTab = location.state?.documentsTab;
        if (
          documentsTab === "sent" ||
          documentsTab === "received" ||
          documentsTab === "office" ||
          documentsTab === K1_PACKAGE_PURPOSE_TAB ||
          documentsTab === FILED_COPIES_PURPOSE_TAB ||
          documentsTab === "requested"
        ) {
          setActiveTab(documentsTab);
        }

        // Get clientId from notification state (initiated_user_id)
        const clientId = location.state?.clientId;

        // If clientId is provided, use that client directly
        if (clientId) {
          const targetClient = clientData.activeClients.find(
            (c) => c.client_id === clientId,
          );

          if (!targetClient) {
            console.warn("Client not found:", clientId);
            searchInProgressRef.current = false;
            return;
          }

          // Select the client first
          if (HOME_USER_ID !== clientId) {
            const selectedClient = clientData.activeClients.find(
              (c) => c.client_id === clientId,
            );
            if (selectedClient) {
              setHOME_USER_ID(clientId);
              setNavPath([{ id: 0, name: "Home", created_by: 0 }]);
              setHOME_FOLDER(selectedClient.s3_root_folder);
              // Wait for state to update
              await new Promise((resolve) => setTimeout(resolve, 500));
            }
          }

          const clientHomeFolder =
            targetClient.s3_root_folder || targetClient.home_folder || "Home";

          // Handle folder opening
          if (location.state?.openFolder && location.state?.folderId) {
            const result = await searchFolderRecursively(
              location.state.folderId,
              clientId,
              clientHomeFolder,
              undefined,
              undefined,
              notificationCategory,
            );

            if (result && result.folderNavPath) {
              setNavPath(result.folderNavPath);
              setCurrentIndex(result.folderNavPath.length - 1);
              searchInProgressRef.current = false;
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname,
              );
              return;
            } else {
              console.warn("Folder not found:", location.state.folderId);
              searchInProgressRef.current = false;
            }
          }

          // Handle document opening
          if (
            location.state?.openDocument &&
            location.state?.documentId &&
            !documentOpenedRef.current
          ) {
            documentOpenedRef.current = true;
            const result = await searchDocumentRecursively(
              location.state.documentId,
              clientId,
              clientHomeFolder,
              undefined,
              undefined,
              notificationCategory,
            );

            if (result && result.folderNavPath) {
              setNavPath(result.folderNavPath);
              setCurrentIndex(result.folderNavPath.length - 1);
              notificationFolderReadyRef.current = true;
              searchInProgressRef.current = false;
              return;
            } else {
              console.warn("Document not found:", location.state.documentId);
              handleStaleClientDocumentNotification();
              return;
            }
          }
        } else {
          // If no clientId, search across all clients (fallback)
          console.warn("No clientId provided, searching all clients");
          for (const client of clientData.activeClients) {
            const clientHomeFolder =
              client.s3_root_folder || client.home_folder || "Home";

            if (location.state?.openFolder && location.state?.folderId) {
              const result = await searchFolderRecursively(
                location.state.folderId,
                client.client_id,
                clientHomeFolder,
                undefined,
                undefined,
                notificationCategory,
              );

              if (result && result.folderNavPath) {
                // Found - select client and navigate
                if (HOME_USER_ID !== result.clientId) {
                  const selectedClient = clientData.activeClients.find(
                    (c) => c.client_id === result.clientId,
                  );
                  if (selectedClient) {
                    setHOME_USER_ID(result.clientId);
                    setNavPath([{ id: 0, name: "Home", created_by: 0 }]);
                    setHOME_FOLDER(selectedClient.s3_root_folder);
                    await new Promise((resolve) => setTimeout(resolve, 500));
                  }
                }
                setNavPath(result.folderNavPath);
                setCurrentIndex(result.folderNavPath.length - 1);
                searchInProgressRef.current = false;
                window.history.replaceState(
                  {},
                  document.title,
                  window.location.pathname,
                );
                return;
              }
            }

            if (
              location.state?.openDocument &&
              location.state?.documentId &&
              !documentOpenedRef.current
            ) {
              documentOpenedRef.current = true;
              const result = await searchDocumentRecursively(
                location.state.documentId,
                client.client_id,
                clientHomeFolder,
                undefined,
                undefined,
                notificationCategory,
              );

              if (result && result.folderNavPath) {
                // Found - select client and navigate
                if (HOME_USER_ID !== result.clientId) {
                  const selectedClient = clientData.activeClients.find(
                    (c) => c.client_id === result.clientId,
                  );
                  if (selectedClient) {
                    setHOME_USER_ID(result.clientId);
                    setNavPath([{ id: 0, name: "Home", created_by: 0 }]);
                    setHOME_FOLDER(selectedClient.s3_root_folder);
                    await new Promise((resolve) => setTimeout(resolve, 500));
                  }
                }
                setNavPath(result.folderNavPath);
                setCurrentIndex(result.folderNavPath.length - 1);
                notificationFolderReadyRef.current = true;
                searchInProgressRef.current = false;
                return;
              }
            }
          }

          searchInProgressRef.current = false;
          if (location.state?.openDocument) {
            documentOpenedRef.current = false;
            handleStaleClientDocumentNotification();
          }
        }
      };

      performSearch();
    }

    // Reset search flag when notification state is cleared
    if (!location.state?.fromNotification) {
      searchInProgressRef.current = false;
      documentOpenedRef.current = false;
      documentUnavailableNotifiedRef.current = false;
      notificationFolderReadyRef.current = false;
    }
  }, [
    location.state?.fromNotification,
    location.state?.clientId,
    location.state?.folderId,
    location.state?.documentId,
    clientData?.activeClients?.length,
  ]);

  // Handle document opening after files are loaded in the target folder
  useEffect(() => {
    if (
      location.state?.fromNotification &&
      location.state?.openDocument &&
      location.state?.documentId &&
      userFiles.length > 0 &&
      documentOpenedRef.current
    ) {
      const documentToOpen = userFiles.find(
        (file) => file.client_document_id === location.state.documentId,
      );

      if (documentToOpen) {
        // Small delay to ensure folder navigation is complete
        setTimeout(() => {
          viewDownloadFileHandler("Preview", documentToOpen);
          documentOpenedRef.current = false; // Reset after opening
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname,
          );
        }, 500);
      } else if (notificationFolderReadyRef.current) {
        handleStaleClientDocumentNotification();
      }
    }

    // Reset ref when location changes
    if (!location.state?.fromNotification) {
      documentOpenedRef.current = false;
    }
  }, [userFiles, location.state, navPath]);

  const getPath = () => {
    const lastPath = navPath[navPath.length - 1];

    if (lastPath.name === "Home") {
      return { id: 0, name: HOME_FOLDER, created_by: "001" };
    }
    return lastPath;
  };

  const getKeyPath = () => {
    let keyPathArr = [...navPath];
    keyPathArr.splice(0, 1, { id: 0, name: documentHomeForWrites });
    const keyPath = keyPathArr.map((u) => u.name).join("/");
    return keyPath;
  };

  const clientsList = useMemo(() => {
    if (localStorage.getItem("user_role") === "client") {
      return [];
    }

    if (!clientData?.activeClients) {
      return [];
    }

    // Map first, then sort by the complete display value for accurate alphabetical ordering
    const mappedClients = clientData.activeClients.map((data) => ({
      id: data.client_id,
      value: `${data.first_name} ${data.last_name} - ${data.email}`,
    }));

    // Sort by the complete display value (case-insensitive)
    return mappedClients.sort((a, b) => {
      const valueA = (a.value || "").toLowerCase();
      const valueB = (b.value || "").toLowerCase();
      return valueA.localeCompare(valueB);
    });
  }, [clientData]);

  const chooseClient = async (e) => {
    const selectedClient = clientData.activeClients.find(
      (data) => data.client_id === e,
    );
    const selectedType = getClientTypeFromRecord(selectedClient);
    setDocCategory(selectedType === "business" ? "business" : "individual");
    setHOME_USER_ID(e);
    setNavPath([{ id: 0, name: "Home", created_by: 0 }]);
    setHOME_FOLDER(selectedClient.s3_root_folder);
  };

  useEffect(() => {
    dispatch(CLIENT_ACTION.getActiveClients());
  }, [dispatch]);

  // Keep fileStructure managed via getFoldersFiles to avoid overwriting with single doc_type payloads

  useEffect(() => {
    if (HOME_USER_ID && isDocumentsFolderTab(activeTab)) {
      getFoldersFiles();
    }
  }, [navPath, activeTab, docCategoryQueryValue, selectedClientBusinessId, HOME_FOLDER]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (navPath.length > 0) {
      getFolderType();
    }
  }, [navPath, userFolders]); // eslint-disable-line react-hooks/exhaustive-deps

  // Clear pending manual tab switch once home + target tab are applied.
  useEffect(() => {
    const pending = pendingTabSwitchRef.current;
    if (!pending) return;
    if (activeTab === pending && isDocumentsHomePath(navPath)) {
      pendingTabSwitchRef.current = null;
    }
  }, [activeTab, navPath]);

  // Auto-select tab when user opens a folder (not during manual tab switches).
  useEffect(() => {
    if (pendingTabSwitchRef.current) return;
    if (!isDocumentsFolderTab(activeTab)) return;

    const current = navPath[navPath.length - 1];
    if (!current || Number(current.id) === 0) return;

    const folderType =
      current.folder_type ||
      filetype ||
      resolveFolderTypeFromNav(navPath, homeFolders, HOME_FOLDER);
    const nextTab = resolveActiveTabFromFolderType(folderType, {
      isClient,
      activeDocCategory,
      autoSwitchSentReceived: isClient,
    });
    if (nextTab && nextTab !== activeTab) {
      setActiveTab(nextTab);
    }
  }, [navPath, filetype, isClient, activeDocCategory, activeTab, homeFolders, HOME_FOLDER]);

  // Leave Filed Copies tab when document category no longer matches.
  useEffect(() => {
    if (activeDocCategory === "individual" && activeTab === K1_PACKAGE_PURPOSE_TAB) {
      setActiveTab("received");
    }
    if (activeDocCategory === "business" && activeTab === FILED_COPIES_PURPOSE_TAB) {
      setActiveTab("received");
    }
  }, [activeDocCategory, activeTab]);

  // Reset breadcrumbs to home when switching tabs or document categories
  useEffect(() => {
    if (pendingTabSwitchRef.current) return;
    setNavPath((prev) => {
      if (isDocumentsHomePath(prev)) return prev;
      return DOCUMENTS_HOME_NAV;
    });
  }, [activeTab, activeDocCategory]);

  const getDocTypesForActiveTab = () => {
    if (activeTab === "office") return ["office"];
    if (isFiledCopiesTab && activeFiledCopiesDocType) {
      return [activeFiledCopiesDocType];
    }
    if (activeTab === "sent") return [isClient ? "client" : "emp"];
    if (activeTab === "received") return [isClient ? "emp" : "client"];
    return isClient ? ["client", "emp"] : ["emp", "client", "office"];
  };

  const foldersFilesLoadIdRef = useRef(0);

  const getFoldersFiles = async () => {
    if (!isDocumentsFolderTab(activeTab)) return;
    const loadId = ++foldersFilesLoadIdRef.current;
    let path = getPath();

    try {
      const folderResponse = await dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: HOME_USER_ID,
          folder_name: path.name,
          folder_id: path.id,
          folder_type: path.folder_type,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );
      if (loadId !== foldersFilesLoadIdRef.current) return;

      if (folderResponse.payload) {
        const scopedFolders = scopedToActiveCategory(folderResponse.payload);
        setHomeFolders(scopedFolders);
        setFileStructure((prev) => ({
          ...prev,
          folders: scopedFolders,
        }));
      }
    } catch (error) {
      console.error("ERROR IN getUserFolders: ", error);
    }

    // One getUserDocs call per visible tab (sent / received / office doc_type).
    try {
      const docTypes = getDocTypesForActiveTab();

      const responses = await Promise.all(
        docTypes.map((dt) =>
          dispatch(
            DOCUMENT_ACTION.getUserFiles({
              user_id: HOME_USER_ID,
              folder_name: path.name,
              folder_id: path.id,
              doc_type: dt,
              ...(docCategoryQueryValue && shouldIncludeDocumentCategoryInFetch(dt)
                ? categoryFetchParams
                : {}),
            }),
          ).unwrap(),
        ),
      );

      if (loadId !== foldersFilesLoadIdRef.current) return;

      const aggregated = responses.reduce((acc, res) => {
        const files = extractUserFilesList(res);
        if (files.length) acc.push(...files);
        return acc;
      }, []);

      const scopedFiles = aggregated
        .filter((file) => fileBelongsToCurrentFolder(file, navPath))
        .filter((file) =>
          docCategoryQueryValue
            ? recordMatchesClientCategory(file, docCategoryQueryValue)
            : true,
        );

      setFileStructure((prev) => ({ ...prev, files: scopedFiles }));
    } catch (error) {
      console.error("ERROR IN getUserFiles: ", error);
    }
  };

  const getFolderType = () => {
    setFiletype(resolveFolderTypeFromNav(navPath, homeFolders, HOME_FOLDER));
  };

  const handleOpen = async (
    folder_name,
    id,
    created_by,
    index,
    folder_type,
  ) => {
    let newPath;

    if (index !== undefined) {
      navPath.slice(index + 1).forEach((segment) => {
        if (segment?.id != null) {
          dismissFolderFileHighlights(segment.id, currentDocTab);
        }
      });
      newPath = navPath.slice(0, index + 1);
      setCurrentIndex(index);
    } else {
      newPath = [
        ...navPath,
        { id, name: folder_name, created_by, folder_type },
      ];
      setCurrentIndex(navPath.length);
    }

    setNavPath(newPath);

    if (index === undefined && id) {
      clearFolderUnread(id, currentDocTab);
    }
  };

  const uploadFileHandler = async (
    fileData,
    doc_type,
    filedCopiesTags = [],
    filedCopiesServiceId = "",
  ) => {
    if (hasInvalidDocumentUploadFiles(fileData)) {
      Toaster.error(
        `One or more files exceed ${DOCUMENT_UPLOAD_MAX_MB} MB or use a blocked file type.`,
      );
      return;
    }

    let path = getModalPath();
    let formData = new FormData();
    for (var i = 0; i <= fileData.length - 1; i++) {
      formData.append("file", fileData[i]);
    }

    // Always set doc_type to 'client' if client is logged in
    const effectiveDocType =
      localStorage.getItem("user_role") === "client" ? "client" : doc_type;

    let uploadPath = path;
    let uploadDirectoryDetails =
      folderModalPath.length > 0 ? [...folderModalPath] : [...navPath];

    formData.append("path", buildKeyPathFromDirectoryDetails(uploadDirectoryDetails));
    formData.append("home_folder", documentHomeForWrites);
    formData.append("directory_details", JSON.stringify(uploadDirectoryDetails));
    formData.append("folder_name", path.name);
    formData.append("folder_id", path.id);
    formData.append("doc_type", effectiveDocType);
    formData.append("user_id", HOME_USER_ID);
    if (docCategoryQueryValue) {
      formData.append("document_category", docCategoryQueryValue);
      appendBusinessIdToFormData(formData, {
        documentCategory: docCategoryQueryValue,
        clientBusinessId: selectedClientBusinessId,
      });
    }

    if (requiresFiledCopiesDocumentTag(doc_type)) {
      appendFiledCopiesTagsToFormData(formData, fileData, filedCopiesTags);
      appendFiledCopiesServiceToFormData(formData, filedCopiesServiceId);
    }

    if (pendingFolders.length > 0) {
      for (const folder of pendingFolders) {
        const effectiveFolderType = isClient ? "client" : folder.folder_type;
        const folderResponse = await DOCUMENT_ACTION.createFolder({
          user_id: HOME_USER_ID,
          folderName: folder.name,
          parentFolderName: uploadPath.name,
          parentFolderId: uploadPath.id,
          folder_type: effectiveFolderType,
          path: buildKeyPathFromDirectoryDetails(uploadDirectoryDetails),
          home_folder: documentHomeForWrites,
          directory_details: JSON.stringify(uploadDirectoryDetails),
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        });

        if (folderResponse.status === 200 && folderResponse.data.status === 1) {
          const createdFolder = folderResponse.data.data;
          const createdFolderPath = {
            id:
              createdFolder.client_folder_id ??
              createdFolder.folder_id ??
              createdFolder.id,
            name: createdFolder.folder_name || folder.name,
            created_by: createdFolder.created_by || 0,
            folder_type: effectiveFolderType,
          };
          uploadPath = {
            ...createdFolderPath,
          };
          uploadDirectoryDetails = [...uploadDirectoryDetails, createdFolderPath];
        } else {
          Toaster.error("Error occurred while creating the folder");
          return;
        }
      }

      formData.set("folder_name", uploadPath.name);
      formData.set("folder_id", uploadPath.id);
      formData.set("directory_details", JSON.stringify(uploadDirectoryDetails));
      formData.set("path", buildKeyPathFromDirectoryDetails(uploadDirectoryDetails));
    }

    // Explicit "true"/"false" strings — multipart booleans become strings; backend must parse strictly.
    const shouldSendEmail =
      !isInternalPurposeDocType(effectiveDocType) && Boolean(sendNotifications);
    formData.append("send_email", shouldSendEmail ? "true" : "false");

    if (localStorage.getItem("user_role") === "client") {
      const USER_DATA = JSON.parse(localStorage.getItem("USER_DATA"));
      formData.append("to_email", USER_DATA.employee_email);
      formData.append("first_name", USER_DATA.employee);
      formData.append("user_role", "client");
    } else {
      // Get the selected client data
      const selectedClient = clientData.activeClients?.find(
        (client) => client.client_id === HOME_USER_ID,
      );

      formData.append("to_email", selectedClient?.email || "");
      formData.append("from_email", "noreply@finlotax.com");
      formData.append("first_name", selectedClient?.first_name || "");
      formData.append("user_role", "employee");
    }

    try {
      const response = await DOCUMENT_ACTION.uploadFile({
        formData,
      });
      if (response.status === 200 && response.data.status === 1) {
        if (
          requiresFiledCopiesDocumentTag(doc_type) &&
          filedCopiesServiceId
        ) {
          const serviceRes = await markFiledCopiesServiceCompleted({
            updateClientServiceStatus: CLIENT_ACTION.updateClientServiceStatus,
            clientId: HOME_USER_ID,
            clientServiceId: filedCopiesServiceId,
          });
          if (serviceRes?.status !== 1) {
            Toaster.warning(
              serviceRes?.message ||
                "Document uploaded but could not mark the service as completed",
            );
          }
        }

        Toaster.success("Document Uploaded Successfully");

        handleCloseModal();

        await getFoldersFiles();
      } else {
        Toaster.error("Error occurred while uploading the document");
      }
    } catch (error) {
      Toaster.error("Error occurred while uploading the document");
    }
  };

  const createFolderHandler = async (newFolderName, folder_type) => {
    let path = getPath();
    // Always set folder_type to 'client' if client is logged in
    const effectiveFolderType = isClient ? "client" : folder_type;
    const folderCategoryPayload = docCategoryQueryValue
      ? categoryFetchParams
      : {};
    try {
      const response = await DOCUMENT_ACTION.createFolder({
        user_id: HOME_USER_ID,
        folderName: newFolderName,
        parentFolderName: path.name,
        parentFolderId: path.id,
        folder_type: effectiveFolderType,
        path: getKeyPath(),
        home_folder: documentHomeForWrites,
        directory_details: JSON.stringify(navPath),
        ...folderCategoryPayload,
      });

      if (response.status === 200 && response.data.status === 1) {
        Toaster.success("Folder created successfully");
        handleCloseModal();

        await getFoldersFiles();
      } else {
        Toaster.error("Error occurred while creating the folder");
      }
    } catch (err) {
      Toaster.error("Error occurred while creating the folder");
    }
  };

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    docdata: null,
    folder_name: "",
    document_name: "",
  });

  const [deleteFolderDialog, setDeleteFolderDialog] = useState({
    open: false,
    folderData: null,
  });

  const handleDelete = (docdata, folder_name, document_name) => {
    setDeleteDialog({
      open: true,
      docdata,
      folder_name,
      document_name,
    });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({
      open: false,
      docdata: null,
      folder_name: "",
      document_name: "",
    });
  };

  const confirmDelete = async () => {
    if (!deleteDialog.docdata) return;
    const path = getPath();

    try {
      await DOCUMENT_ACTION.deleteFile(
        deleteDialog.docdata["client_document_id"],
        deleteDialog.folder_name,
        deleteDialog.document_name,
      );

      // Optimistically remove from local state so UI updates immediately
      const targetDocId = deleteDialog.docdata.client_document_id;
      setFileStructure((prev) => ({
        ...prev,
        files: prev.files.filter((f) => f.client_document_id !== targetDocId),
      }));

      dispatch(
        DOCUMENT_ACTION.getUserFiles({
          user_id: HOME_USER_ID,
          folder_name: deleteDialog.folder_name,
          folder_id: path.id,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );

      // Refresh downloaded documents section to remove deleted file instantly
      setDownloadedRefreshKey((k) => k + 1);
      dispatch(
        DOCUMENT_ACTION.getAllClientDocuments({
          client_id: HOME_USER_ID,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );
    } catch (error) {
      console.error("Error deleting item:", error);
    } finally {
      closeDeleteDialog();
    }
  };

  const handleRename = async (docdata, newName) => {
    let formData = new FormData();
    let path = getPath();

    formData.append("client_document_id", docdata.client_document_id);
    formData.append("folder_name", docdata.folder_name);
    formData.append("document_name", docdata.document_name);
    formData.append("new_document_name", newName);
    formData.append("home_folder", documentHomeForWrites);
    formData.append("user_id", HOME_USER_ID);
    formData.append("client_folder_id", docdata.client_folder_id);
    formData.append("first_name", docdata.first_name);
    formData.append("last_name", docdata.last_name);
    formData.append("directory_details", docdata.directory_details);
    formData.append("document_type", docdata.document_type);
    formData.append("doc_type", docdata.doc_type);
    formData.append("document_extension", docdata.document_extension);
    formData.append("document_link", docdata.document_link);
    formData.append("document_size", docdata.document_size);
    formData.append("status", docdata.status);

    try {
      const response = await DOCUMENT_ACTION.renameFile(formData);

      if (response.status === 200) {
        // Optimistically update local state for immediate UI feedback
        const renamedId = docdata.client_document_id;
        setFileStructure((prev) => ({
          ...prev,
          files: prev.files.map((f) =>
            f.client_document_id === renamedId
              ? { ...f, document_name: newName }
              : f,
          ),
        }));

        dispatch(
          DOCUMENT_ACTION.getUserFiles({
            folder_id: path.id,
            folder_name: formData.get("folder_name"),
            user_id: HOME_USER_ID,
            ...(docCategoryQueryValue
              ? categoryFetchParams
              : {}),
          }),
        );

        Toaster.success("Document renamed successfully!");
        setRenameModalOpen(false);
      } else {
        Toaster.error("Failed to rename the file/folder.");
        setRenameModalOpen(false);
      }
    } catch (error) {
      console.error("Error renaming file:", error);
      Toaster.error("Error occurred while renaming.");
    }
  };

  const handleEmailNotificationChange = (enabled) => {
    setSendNotifications(Boolean(enabled));
  };

  const viewDownloadFileHandler = async (
    type,
    {
      folder_name,
      document_name,
      document_type,
      client_document_id,
      client_folder_id,
      // For downloaded files, pass the full file object to construct correct path
      ...fileData
    },
  ) => {
    if (type === "Delete") {
      const docdata = userFiles.find(
        (file) => file.document_name === document_name,
      );
      handleDelete(docdata, folder_name, document_name);
    } else {
      if (type === "Preview" && client_document_id) {
        dismissFileHighlight(client_document_id);
      }
      // If this is a downloaded file (has directory_details or folder_path), use its actual path
      // Otherwise, use current navigation path
      let fileURL;
      if (
        fileData.directory_details ||
        fileData.folder_path ||
        fileData.folder_name
      ) {
        const constructedURL = buildFileURLFromDocument({
          document_name,
          directory_details: fileData.directory_details,
          folder_path: fileData.folder_path,
          folder_name: fileData.folder_name,
        });
        fileURL = constructedURL || `${getKeyPath()}/${document_name}`;
      } else {
        fileURL = `${getKeyPath()}/${document_name}`;
      }

      const previewTab = type === "Preview" ? openDocumentPreviewTab() : null;
      const response = await DOCUMENT_ACTION.downloadViewFile({
        fileURL,
        folder_name: folder_name || fileData.folder_name,
        document_name,
        document_type,
        client_document_id,
        type,
      });
      if (type === "Preview") {
        await openDocumentInNewTab(
          response?.raw,
          document_type,
          document_name,
          previewTab,
        );
      }
      if (response["status"] === 200) {
        if (type === "Download" && !isClient) {
          // Optimistically update local state to mark file as downloaded immediately
          setFileStructure((prev) => ({
            ...prev,
            files: prev.files.map((f) =>
              f.client_document_id === client_document_id
                ? { ...f, downloaded: 1 }
                : f,
            ),
          }));
        }

        // Refresh current folder files + folders so API-driven `downloaded` updates reflect immediately
        dispatch(
          DOCUMENT_ACTION.getUserFolders({
            user_id: HOME_USER_ID,
            folder_name: folder_name,
            folder_id: client_folder_id,
            ...(docCategoryQueryValue
              ? categoryFetchParams
              : {}),
          }),
        );
        const folderResponse = dispatch(
          DOCUMENT_ACTION.getUserFiles({
            user_id: HOME_USER_ID,
            folder_name: folder_name,
            folder_id: client_folder_id,
            ...(docCategoryQueryValue
              ? categoryFetchParams
              : {}),
          }),
        );
        if (folderResponse.payload) {
          setHomeFolders(folderResponse.payload);
        }

        if (type === "Download" && !isClient) {
          // Trigger downloaded section refresh and reload all client documents
          setDownloadedRefreshKey((k) => k + 1);
          // Refresh all client documents to update the downloaded status immediately
          dispatch(
            DOCUMENT_ACTION.getAllClientDocuments({
              client_id: HOME_USER_ID,
              ...(docCategoryQueryValue
                ? categoryFetchParams
                : {}),
            }),
          );
        }
      }
    }
  };

  const handleRenameFolder = async (folderData, newName) => {
    const path = getPath();

    try {
      await dispatch(
        DOCUMENT_ACTION.renameFolder({
          folder_id: folderData.folder_id,
          folder_name: folderData.folder_name,
          new_folder_name: newName,
          oldFolderPath: folderData.s3_folder_location,
          home_folder: folderData.home_folder,
          newFolderPath: `https://finlotax-user-docs.s3.us-west-1.amazonaws.com/${getKeyPath()}/${newName}`,
          userId: HOME_USER_ID,
        }),
      ).unwrap();

      // Optimistically update local state for immediate UI feedback
      const targetFolderId =
        folderData.client_folder_id !== undefined
          ? folderData.client_folder_id
          : folderData.folder_id;
      setFileStructure((prev) => ({
        ...prev,
        folders: prev.folders.map((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId === targetFolderId
            ? { ...f, folder_name: newName }
            : f;
        }),
      }));
      setHomeFolders((prev) =>
        prev.map((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId === targetFolderId
            ? { ...f, folder_name: newName }
            : f;
        }),
      );

      dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: HOME_USER_ID,
          folder_name: path.name,
          folder_id: path.id,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );

      Toaster.success("Folder renamed successfully!");
      setRenameFolderModalOpen(false);
    } catch (error) {
      console.error("Error renaming folder:", error);
      Toaster.error("Failed to rename folder.");
      setRenameFolderModalOpen(false);
    }
  };

  const handleDeleteFolder = (folderData) => {
    setDeleteFolderDialog({
      open: true,
      folderData,
    });
  };

  const closeDeleteFolderDialog = () => {
    setDeleteFolderDialog({
      open: false,
      folderData: null,
    });
  };

  const confirmDeleteFolder = async () => {
    if (!deleteFolderDialog.folderData) return;
    const folderData = deleteFolderDialog.folderData;
    const path = getPath();

    try {
      await dispatch(
        DOCUMENT_ACTION.deleteFolder({
          folder_id: folderData.folder_id || folderData.client_folder_id,
          folder_name: folderData.folder_name,
          folderPath: folderData.s3_folder_location,
          home_folder: folderData.home_folder,
          userId: HOME_USER_ID,
        }),
      ).unwrap();

      // Optimistically remove from local state so UI updates immediately
      const targetFolderId =
        folderData.client_folder_id !== undefined
          ? folderData.client_folder_id
          : folderData.folder_id;

      setFileStructure((prev) => ({
        ...prev,
        folders: prev.folders.filter((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId !== targetFolderId;
        }),
      }));

      setHomeFolders((prev) =>
        prev.filter((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId !== targetFolderId;
        }),
      );

      dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: HOME_USER_ID,
          folder_name: path.name,
          folder_id: path.id,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );
    } catch (error) {
      console.error("Error deleting folder:", error);
      Toaster.error("Failed to delete folder.");
    } finally {
      closeDeleteFolderDialog();
    }
  };

  const handleCreateFolderDirectly = () => {
    if (newFolderName.trim() === "") {
      Toaster.warning("Please select folder name");
      return;
    }
    let folder_type = "emp";
    if (isModalOpen === "client_add_folder") {
      folder_type = "client";
    } else if (isModalOpen === "office_add_folder") {
      folder_type = "office";
    } else if (isModalOpen === "k1_package_add_folder") {
      folder_type = DOC_TYPE_K1_PACKAGE;
    } else if (isModalOpen === "filed_copies_add_folder") {
      folder_type = DOC_TYPE_FILED_COPIES;
    } else if (!isClient) {
      folder_type = resolveStaffDocType(documentModalContextTabRef.current);
    }
    createFolderHandler(newFolderName.trim(), folder_type);
  };

  const modelAction = () => {
    let folder_type = "emp";
    let doc_type = "emp";
    const isRootFolderContext = navPath.length === 1 && navPath[0]?.id === 0;
    if (isModalOpen.includes("_upload")) {
      if (fileData.length === 0) {
        Toaster.warning("Please upload document");
        return;
      }
      if (isModalOpen === "client_upload") {
        doc_type = "client";
      } else if (isModalOpen === "office_upload") {
        doc_type = "office";
      } else if (isModalOpen === "k1_package_upload") {
        doc_type = DOC_TYPE_K1_PACKAGE;
      } else if (isModalOpen === "filed_copies_upload") {
        doc_type = DOC_TYPE_FILED_COPIES;
      } else if (
        isModalOpen === "emp_upload" ||
        isModalOpen.includes("add_folder_upload")
      ) {
        const isClientRole = localStorage.getItem("user_role") === "client";
        doc_type = isClientRole
          ? "emp"
          : resolveStaffDocType(documentModalContextTabRef.current);
      }
      const tagValidationError = requiresFiledCopiesDocumentTag(doc_type)
        ? validateFiledCopiesUpload({
            files: fileData,
            tags: filedCopiesFileTags,
            clientServiceId: filedCopiesSelectedServiceId,
          })
        : null;
      if (tagValidationError) {
        Toaster.warning(tagValidationError);
        return;
      }
      uploadFileHandler(
        fileData,
        doc_type,
        filedCopiesFileTags,
        filedCopiesSelectedServiceId,
      );
    } else if (isModalOpen.includes("add_folder")) {
      if (folderModalStage === "root") {
        if (newFolderName.trim() === "") {
          Toaster.warning(
            isRootFolderContext
              ? "Please select folder name"
              : "Please enter folder name",
          );
          return;
        }
        if (isModalOpen === "client_add_folder") {
          folder_type = "client";
        } else if (isModalOpen === "office_add_folder") {
          folder_type = "office";
        } else if (isModalOpen === "k1_package_add_folder") {
          folder_type = DOC_TYPE_K1_PACKAGE;
        } else if (isModalOpen === "filed_copies_add_folder") {
          folder_type = DOC_TYPE_FILED_COPIES;
        } else if (!isClient) {
          folder_type = resolveStaffDocType(documentModalContextTabRef.current);
        }
        const selectedFolder = newFolderName.trim();
        const effectiveFolderType = isClient ? "client" : folder_type;

        const existingFolder = (userFolders || []).find(
          (f) =>
            f.folder_name?.trim().toLowerCase() ===
              selectedFolder.toLowerCase() &&
            folderMatchesActiveTab(f),
        );

        if (existingFolder) {
          const activeFolder = {
            id:
              existingFolder.client_folder_id ??
              existingFolder.folder_id ??
              existingFolder.id,
            name: existingFolder.folder_name,
            created_by: existingFolder.created_by || 0,
            folder_type: existingFolder.folder_type,
          };
          setFolderModalPath([
            { id: 0, name: "Home", created_by: 0 },
            activeFolder,
          ]);
          setFolderModalTitle(activeFolder.name);
          setFolderModalStage("upload");
          setNewFolderName("");
          setModalOpen(
            folderModalScope === "root"
              ? "root_add_folder_upload"
              : "inner_add_folder_upload",
          );
          return;
        }

        setPendingFolders((prev) => [
          ...prev,
          { name: selectedFolder, folder_type: effectiveFolderType },
        ]);
        setFolderModalTitle(selectedFolder);
        setFolderModalPath([
          ...navPath,
          { id: selectedFolder, name: selectedFolder },
        ]);
        setNewFolderName("");
        setFolderModalStage("upload");
        setModalOpen(
          folderModalScope === "root"
            ? "root_add_folder_upload"
            : "inner_add_folder_upload",
        );
        return;
      }

      if (folderModalStage === "inner") {
        if (newFolderName.trim() === "") {
          Toaster.warning("Please enter folder name");
          return;
        }
        if (isModalOpen === "client_add_folder") {
          folder_type = "client";
        } else if (isModalOpen === "office_add_folder") {
          folder_type = "office";
        } else if (isModalOpen === "k1_package_add_folder") {
          folder_type = DOC_TYPE_K1_PACKAGE;
        } else if (isModalOpen === "filed_copies_add_folder") {
          folder_type = DOC_TYPE_FILED_COPIES;
        } else if (!isClient) {
          folder_type = resolveStaffDocType(documentModalContextTabRef.current);
        }

        // Inner add from an existing folder should create immediately.
        if (folderModalScope === "inner") {
          createFolderHandler(newFolderName.trim(), folder_type);
          return;
        }

        const nestedFolder = newFolderName.trim();
        const effectiveFolderType = isClient ? "client" : folder_type;
        setPendingFolders((prev) => [
          ...prev,
          { name: nestedFolder, folder_type: effectiveFolderType },
        ]);
        setFolderModalTitle(nestedFolder);
        setFolderModalPath((prev) => [
          ...(prev.length > 0 ? prev : navPath),
          { id: nestedFolder, name: nestedFolder },
        ]);
        setNewFolderName("");
        setFolderModalStage("menu");
        setModalOpen("add_folder");
      }
    }
  };

  const bulkDownloadHandler = async ({ folder_name, user_id, folder_id }) => {
    try {
      await DOCUMENT_ACTION.getBulkFiles({
        user_id,
        folder_name,
        folder_id,
        path: getKeyPath(),
      });

      // Refresh listing after bulk download (API may mark folder/docs as downloaded)
      const path = getPath();
      dispatch(
        DOCUMENT_ACTION.getUserFolders({
          user_id: HOME_USER_ID,
          folder_name: path.name === "Home" ? HOME_FOLDER : path.name,
          folder_id: path.id,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );
      dispatch(
        DOCUMENT_ACTION.getUserFiles({
          user_id: HOME_USER_ID,
          folder_name: path.name === "Home" ? HOME_FOLDER : path.name,
          folder_id: path.id,
          ...(docCategoryQueryValue
            ? categoryFetchParams
            : {}),
        }),
      );
      setDownloadedRefreshKey((k) => k + 1);
    } catch (e) {
      // keep existing behavior; download errors are already handled in action
    }
  };

  const renderDownloadedSection = () => {
    // Clients see all documents in the main list; downloaded section is staff-only.
    if (isClient) return null;
    if (!isDocumentsFolderTab(activeTab)) return null;
    if (!HOME_USER_ID) return null;

    // Only show downloaded section when inside a folder (not at root/Home)
    const isAtRoot = navPath.length === 1 && navPath[0]?.id === 0;
    if (isAtRoot) return null;

    return (
      <div
        className="documents-section downloaded-files"
        style={{ marginTop: 35 }}
      >
        <div className="documents-section-header">
          <h3 className="documents-section-title">Downloaded Documents</h3>
          <IconButton
            className={`documents-section-toggle ${isDownloadedOpen ? "open" : ""}`}
            onClick={() => {
              setIsDownloadedOpen((v) => {
                const next = !v;
                if (next && initialUserRole !== "client" && !HOME_USER_ID) {
                  Toaster.warning("Please select a client");
                  return false;
                }
                if (next && suppressDownloadedOnEntryRef.current) {
                  // User explicitly opened the section; allow loading again
                  suppressDownloadedOnEntryRef.current = false;
                  setDownloadedRefreshKey((k) => k + 1);
                }
                return next;
              });
            }}
            size="small"
          >
            <ExpandMore />
          </IconButton>
        </div>

        {isDownloadedOpen && (
          <div className="documents-section-content">
            <table className="documents-table">
              <thead>
                <tr>
                  <th style={{ width: "38%" }}>Document</th>
                  <th style={{ width: "14%" }}>Date</th>
                  <th style={{ width: "14%" }}>Created At</th>
                  <th style={{ width: "14%" }}>File Type</th>
                  <th style={{ width: "10%", textAlign: "right" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {isDownloadedLoading ? (
                  <tr>
                    <td colSpan={5} className="documents-empty-cell">
                      Loading...
                    </td>
                  </tr>
                ) : downloadedItems.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="documents-empty-cell">
                      No downloaded documents
                    </td>
                  </tr>
                ) : (
                  downloadedItems.map((data) => {
                    const folderPath =
                      data.__folderPath && data.__folderPath !== "Home"
                        ? data.__folderPath
                        : null;
                    return (
                      <tr
                        key={`downloaded-${data.client_document_id}-${data.__folderPath}`}
                        className="documents-row"
                        onClick={() => viewDownloadFileHandler("Preview", data)}
                      >
                        <td className="doc-name-cell">
                          {getFileTypeIcon(data.document_type)}
                          <div className="doc-name-text">
                            <div className="doc-name-primary">
                              {data.document_name}
                            </div>
                            {folderPath && (
                              <div className="doc-name-secondary">
                                {folderPath}
                              </div>
                            )}
                          </div>
                        </td>
                        <td>{dateTimeFormatter(data.updatedAt)}</td>
                        <td>{formatDocumentCreatedAt(data)}</td>
                        <td>{getReadableFileType(data.document_type)}</td>
                        <td
                          className="doc-action-cell"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <IconButton
                            onClick={() =>
                              viewDownloadFileHandler("Download", data)
                            }
                          >
                            <GetApp fontSize="small" />
                          </IconButton>
                          <FileActionMenu fileData={data} />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const hasExistingFolder =
    folderModalPath.length > 1 &&
    folderModalPath[folderModalPath.length - 1].name?.toLowerCase() !==
      pendingFolders[0]?.name?.toLowerCase();

  const modalBreadcrumbPath =
    pendingFolders.length > 0
      ? [
          ...(hasExistingFolder ? folderModalPath : navPath),
          ...pendingFolders.map((folder) => ({
            id: folder.name,
            name: folder.name,
          })),
        ]
      : folderModalPath.length > 0
        ? folderModalPath
        : navPath.length > 1
          ? navPath
          : [];

  var selectedClientData = "";
  const getAccess = (type) => {
    selectedClientData = clientData.activeClients.find(
      (client) => client.client_id === HOME_USER_ID,
    );

    if (selectedClientData !== undefined) {
      return (
        type === "allclients" ||
        (type === "activeclient" &&
          (selectedClientData.employee_id === localStorage.getItem("user_id") ||
            selectedClientData.sales === localStorage.getItem("user_id"))) ||
        (localStorage.getItem("user_role") !== "admin" &&
          localStorage.getItem("user_id") ===
            navPath[navPath.length - 1].created_by) ||
        localStorage.getItem("user_role") === "admin"
      );
    }
  };

  const openMoveModal = (type, data) => {
    setMoveItem({ type, data });
    setMoveModalOpen(true);
  };

  const closeMoveModal = () => {
    setMoveModalOpen(false);
    setMoveItem(null);
  };

  const refreshAfterMove = async () => {
    setDownloadedRefreshKey((k) => k + 1);
    await getFoldersFiles();
    dispatch(
      DOCUMENT_ACTION.getAllClientDocuments({
        client_id: HOME_USER_ID,
        ...(docCategoryQueryValue
          ? categoryFetchParams
          : {}),
      }),
    );
  };

  const handleMoveConfirm = async ({
    destination,
    documentCategory: destCategory,
    docType: destDocType,
  }) => {
    if (!moveItem) return;
    const dest = destination || {};
    const sourceItem = moveItem.data || {};
    const sourceDocType =
      moveItem.type === "folder"
        ? sourceItem.folder_type
        : sourceItem.doc_type;
    const sourceCategory =
      sourceItem.document_category || activeDocCategory || "individual";
    const targetCategory = destCategory ?? sourceCategory;

    try {
      if (moveItem.type === "folder") {
        const folder = sourceItem;
        const folderId =
          folder.client_folder_id ?? folder.folder_id ?? folder.id;
        const response = await DOCUMENT_ACTION.moveFolder(
          withBusinessDocumentParams(
            {
          folder_id: folderId,
          new_parent_folder_id: dest.id || 0,
          user_id: HOME_USER_ID,
              home_folder: documentHomeForWrites,
          doc_type: destDocType || folder.folder_type,
          new_doc_type: destDocType,
          document_category: targetCategory,
          new_document_category: destCategory,
          source_doc_type: sourceDocType,
          source_document_category: sourceCategory,
          new_parent_folder_name: dest.name,
          new_directory_details: JSON.stringify(dest.navPath || []),
            },
            {
              documentCategory: targetCategory,
              clientBusinessId: selectedClientBusinessId,
            },
          ),
        );
        if (response?.status === 200 && response?.data?.status === 1) {
          Toaster.success("Folder moved successfully");
          await refreshAfterMove();
          closeMoveModal();
        } else {
          Toaster.error(
            response?.data?.message || "Error occurred while moving the folder",
          );
        }
      } else {
        const file = moveItem.data || {};
        const response = await DOCUMENT_ACTION.moveFile(
          withBusinessDocumentParams(
            {
          client_document_id: file.client_document_id,
          new_folder_id: dest.id || 0,
          new_folder_name: dest.name,
          user_id: HOME_USER_ID,
              home_folder: documentHomeForWrites,
          doc_type: destDocType || file.doc_type,
          new_doc_type: destDocType,
          document_category: targetCategory,
          new_document_category: destCategory,
          source_doc_type: sourceDocType,
          source_document_category: sourceCategory,
          new_directory_details: JSON.stringify(dest.navPath || []),
            },
            {
              documentCategory: targetCategory,
              clientBusinessId: selectedClientBusinessId,
            },
          ),
        );
        if (response?.status === 200 && response?.data?.status === 1) {
          Toaster.success("File moved successfully");
          await refreshAfterMove();
          closeMoveModal();
        } else {
          Toaster.error(
            response?.data?.message || "Error occurred while moving the file",
          );
        }
      }
    } catch (e) {
      Toaster.error("Error occurred while moving the item");
    }
  };

  const FileActionMenu = ({ fileData }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleRenameClick = () => {
      setSelectedFile(fileData);
      setNewName(fileData.name);
      setRenameModalOpen(true);
      handleMenuClose();
    };

    const handleMoveClick = () => {
      openMoveModal("file", fileData);
      handleMenuClose();
    };

    const handleSendForSignatureClick = () => {
      setSignatureModal({ open: true, document: fileData });
      handleMenuClose();
    };

    const documentName = fileData.document_name || fileData.name || "";
    const canSendForSignature =
      !isClient &&
      Boolean(HOME_USER_ID) &&
      isSignableDocumentName(documentName);

    // Hide menu for clients when viewing received files
    const isReceivedFile =
      fileData.doc_type === "client" || activeTab === "received";
    if (isClient && isReceivedFile) {
      return null;
    }

    return (
      <>
        <IconButton onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem
            onClick={() => viewDownloadFileHandler("Preview", fileData)}
          >
            <ListItemIcon>
              <Visibility fontSize="small" />
            </ListItemIcon>
            <ListItemText>Preview</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => viewDownloadFileHandler("Download", fileData)}
          >
            <ListItemIcon>
              <GetApp fontSize="small" />
            </ListItemIcon>
            <ListItemText>Download</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleRenameClick}>
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
          </MenuItem>

          {!isClient && (
            <MenuItem onClick={handleMoveClick}>
              <ListItemIcon>
                <DriveFileMoveOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Move</ListItemText>
            </MenuItem>
          )}

          {canSendForSignature && (
            <MenuItem onClick={handleSendForSignatureClick}>
              <ListItemIcon>
                <DrawOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Send for Signature</ListItemText>
            </MenuItem>
          )}

          {canDeleteDocument && (
            <MenuItem
              onClick={() =>
                handleDelete(
                  fileData,
                  fileData.folder_name,
                  fileData.document_name,
                )
              }
            >
              <ListItemIcon>
                <Delete fontSize="small" color="error" />
              </ListItemIcon>

              <ListItemText>Delete</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  const defaultSignatureSigner = useMemo(() => {
    const name = `${clientDetails?.first_name || ""} ${clientDetails?.last_name || ""}`.trim();
    return {
      name: name || clientDetails?.client_name || "",
      email: clientDetails?.email || "",
    };
  }, [clientDetails]);

  const FolderActionMenu = ({ folderData }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleRenameClick = () => {
      setSelectedFolder(folderData);
      setNewName(folderData.folder_name);
      setRenameFolderModalOpen(true);
      handleMenuClose();
    };

    const handleDeleteClick = async () => {
      await handleDeleteFolder(folderData);
      handleMenuClose();
    };

    const handleMoveClick = () => {
      openMoveModal("folder", folderData);
      handleMenuClose();
    };

    // Hide menu for clients when viewing received folders
    const isReceivedFolder =
      folderData.folder_type === "client" || activeTab === "received";
    if (isClient && isReceivedFolder) {
      return null;
    }

    return (
      <>
        <IconButton onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleRenameClick}>
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
          </MenuItem>

          {!isClient && (
            <MenuItem onClick={handleMoveClick}>
              <ListItemIcon>
                <DriveFileMoveOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Move</ListItemText>
            </MenuItem>
          )}

          {canDeleteDocument && (
            <MenuItem onClick={handleDeleteClick}>
              <ListItemIcon>
                <Delete fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  // ---------- helpers for tabs ----------

  // For clients, show add folder/upload in "sent" tab only (type "emp")
  // They can add folder when in home folder or when in their own folders
  const showClientAddFolder =
    isClient &&
    activeTab === "sent" &&
    ((activeDocCategory === "business" && isRootDocumentsFolder) ||
      getKeyPath() === HOME_FOLDER ||
      filetype === "emp" ||
      getPath().created_by === HOME_USER_ID);
  const isTourActive = localStorage.getItem("finlo_tour_completed") !== "true" && localStorage.getItem("finlo_tour_step") === "2";
  const showClientUpload =
    (isClient &&
    activeTab === "sent" &&
    getKeyPath() !== HOME_FOLDER &&
    (filetype === "emp" || getPath().created_by === HOME_USER_ID)) ||
    (isClient && isTourActive);

  const showEmpAddFolder =
    isEmployee &&
    activeTab === "sent" &&
    (filetype === "emp" ||
      filetype === "client" ||
      getKeyPath() === HOME_FOLDER);
  const showEmpUpload =
    isEmployee &&
    activeTab === "sent" &&
    filetype !== "office" &&
    getKeyPath() !== HOME_FOLDER;

  const showStaffReceivedAddFolder =
    isEmployee &&
    activeTab === "received" &&
    (filetype === "client" ||
      filetype === "emp" ||
      getKeyPath() === HOME_FOLDER);
  const showStaffReceivedUpload =
    isEmployee &&
    activeTab === "received" &&
    filetype !== "office" &&
    getKeyPath() !== HOME_FOLDER;

  const showOfficeAddFolder =
    isEmployee &&
    activeTab === "office" &&
    (filetype === "office" || getKeyPath() === HOME_FOLDER);
  const showOfficeUpload =
    isEmployee &&
    activeTab === "office" &&
    filetype === "office" &&
    getKeyPath() !== HOME_FOLDER;

  const showK1PackageAddFolder =
    isEmployee &&
    isK1PackageTab &&
    (filetype === DOC_TYPE_K1_PACKAGE || getKeyPath() === HOME_FOLDER);
  const showK1PackageUpload =
    isEmployee &&
    isK1PackageTab &&
    filetype === DOC_TYPE_K1_PACKAGE &&
    getKeyPath() !== HOME_FOLDER;
  const showIndividualFiledCopiesAddFolder =
    isEmployee &&
    isIndividualFiledCopiesTab &&
    (filetype === DOC_TYPE_FILED_COPIES || getKeyPath() === HOME_FOLDER);
  const showIndividualFiledCopiesUpload =
    isEmployee &&
    isIndividualFiledCopiesTab &&
    filetype === DOC_TYPE_FILED_COPIES &&
    getKeyPath() !== HOME_FOLDER;

  // For clients in "sent" tab: show action column so they can download
  const showActionColumn = true;

  const renderRowsForType = (type) => {
    // Filter folders and files by type
    let folders = scopedToActiveCategory(
      fileStructure.folders.filter((f) => f.folder_type === type),
    );
    let files = scopedToActiveCategory(
      fileStructure.files.filter(
        (f) =>
          f.doc_type === type && fileBelongsToCurrentFolder(f, navPath),
      ),
    );

    // Filter by Sent/Received tab logic
    if (activeTab === "sent") {
      folders = folders.filter(isSentItem);
      files = files.filter(isSentItem);
    } else if (activeTab === "received") {
      folders = folders.filter(isReceivedItem);
      files = files.filter(isReceivedItem);
    }

    // Employees: hide downloaded files from the main list (shown in Downloaded Documents section).
    // Clients: show all files in the main list regardless of downloaded status.
    if (!isClient) {
      files = files.filter((f) => Number(f.downloaded) !== 1);
    }

    const colSpan = showActionColumn ? 5 : 4;

    // Show files even when in Home; only show Empty when both folders and files are absent
    if (!folders.length && !files.length) {
      return (
        <tr>
          <td colSpan={colSpan} className="documents-empty-cell">
            <Empty />
          </td>
        </tr>
      );
    }

    return (
      <>
        {folders.map((data) => {
          const folderUnread = getFolderUnreadCount(
            data.client_folder_id,
            currentDocTab,
          );
          return (
          <tr
            key={`folder-${data.client_folder_id}`}
            className={`documents-row is-folder${
              folderUnread > 0 ? " is-new-unread" : ""
            }`}
            onClick={() =>
              handleOpen(
                data.folder_name,
                data.client_folder_id,
                data.created_by,
                undefined,
                data.folder_type,
              )
            }
          >
            <td className="doc-name-cell">
              {getFileTypeIcon(null, true)}
              <span>{data.folder_name}</span>
            </td>
            <td>{dateTimeFormatter(data.updatedAt)}</td>
            <td>{formatDocumentCreatedAt(data)}</td>
            <td>{getReadableFileType(null, true)}</td>
            {showActionColumn && (
              <td
                className="doc-action-cell"
                onClick={(e) => e.stopPropagation()}
              >
                <IconButton
                  onClick={() =>
                    bulkDownloadHandler({
                      user_id: data.client_id,
                      folder_name: data.folder_name,
                      folder_id: data.client_folder_id,
                    })
                  }
                >
                  <GetApp fontSize="small" />
                </IconButton>
                <FolderActionMenu folderData={data} />
              </td>
            )}
          </tr>
          );
        })}

        {files.length > 0 &&
          files.map((data) => {
            const fileIsNew = isFileHighlighted(
              data.client_document_id,
              currentDocTab,
            );
            return (
            <tr
              key={`file-${data.client_document_id}`}
              className={`documents-row${
                fileIsNew ? " is-new-unread" : ""
              }`}
              onClick={() => viewDownloadFileHandler("Preview", data)}
            >
              <td className="doc-name-cell">
                {getFileTypeIcon(data.document_type)}
                <div className="doc-name-text">
                  <div className="doc-name-primary">{data.document_name}</div>
                  {isFiledCopiesTab && data.document_tag ? (
                    <div className="doc-name-secondary">{data.document_tag}</div>
                  ) : null}
                </div>
              </td>
              <td>{dateTimeFormatter(data.updatedAt)}</td>
              <td>{formatDocumentCreatedAt(data)}</td>
              <td>{getReadableFileType(data.document_type)}</td>
              {showActionColumn && (
                <td
                  className="doc-action-cell"
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconButton
                    onClick={() => viewDownloadFileHandler("Download", data)}
                  >
                    <GetApp fontSize="small" />
                  </IconButton>
                  <FileActionMenu fileData={data} />
                </td>
              )}
            </tr>
            );
          })}
      </>
    );
  };

  return (
    <>
      <div
        className={`documents-page${
          hasDocumentPreviews ? " documents-page-with-preview-dock" : ""
        }`}
        style={{ paddingTop: "1.8rem" }}
      >
        {/* Page title */}
        <div className="documents-top-row">
          {/* Select client (unchanged behaviour) */}
          {localStorage.getItem("user_role") !== "client" && (
            <div className="documents-header-section">
              <h3 className="documents-select-client-title">Select Client</h3>
              <Labelbox
                value={HOME_USER_ID}
                type="select"
                dropdown={clientsList}
                labelname=""
                changeData={(e) => chooseClient(e)}
                className="documents-client-dropdown"
              />
            </div>
          )}
        </div>

        {/* Main content card */}
        {showBusinessSelector && HOME_USER_ID && (
          <ClientBusinessSelector
            businesses={clientBusinesses}
            value={selectedClientBusinessId}
            onChange={setSelectedClientBusinessId}
          />
        )}
        <div className="documents-shell-card">
          {/* Tabs + actions row */}
          <div className="documents-tabs-row">
            <div className="documents-tabs">
              <button
                className={`documents-tab ${
                  activeTab === "received" ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange("received")}
              >
                {isClient ? "Files from FinloTax" : "Client Uploads"}
                <DocumentTabBadge count={documentTabUnread.received} />
              </button>
              <button
                className={`documents-tab ${
                  activeTab === "sent" ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange("sent")}
              >
                {isClient ? "My Uploads" : "FinloTax Uploads"}
                <DocumentTabBadge count={documentTabUnread.sent} />
              </button>
            {!isClient && (
              <button
                className={`documents-tab ${
                  activeTab === "office" ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange("office")}
              >
                Internal Files
                <DocumentTabBadge count={documentTabUnread.office} />
              </button>
            )}
            {!isClient && (
              <button
                className={`documents-tab ${
                  activeTab === "requested" ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange("requested")}
              >
                Documents Requested
                <DocumentTabBadge count={documentTabUnread.requested} />
              </button>
            )}
            {isClient && (
              <button
                className={`documents-tab ${
                  activeTab === "requested" ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange("requested")}
              >
                Pending Files
                <DocumentTabBadge count={documentTabUnread.requested} />
              </button>
            )}
              <button
                className={`documents-tab ${
                activeTab === DOC_TAB_SENT_FOR_SIGNATURE ? "is-active" : ""
              }`}
              onClick={() =>
                handleDocumentTabChange(DOC_TAB_SENT_FOR_SIGNATURE)
              }
            >
              {isClient ? "Files for Signature" : "Sent for Signature"}
            </button>
            {activeDocCategory === "individual" && (
              <button
                className={`documents-tab ${
                  isIndividualFiledCopiesTab ? "is-active" : ""
                }`}
                onClick={() =>
                  handleDocumentTabChange(FILED_COPIES_PURPOSE_TAB)
                }
              >
                {K1_PACKAGE_TAB_LABEL}
                <DocumentTabBadge
                  count={documentTabUnread[FILED_COPIES_PURPOSE_TAB]}
                />
              </button>
            )}
            {activeDocCategory === "business" && (showCategoryChooser || isBusinessClient) && (
              <button
                className={`documents-tab ${
                  isK1PackageTab ? "is-active" : ""
                }`}
                onClick={() => handleDocumentTabChange(K1_PACKAGE_PURPOSE_TAB)}
              >
                {K1_PACKAGE_TAB_LABEL}
                <DocumentTabBadge count={documentTabUnread[K1_PACKAGE_PURPOSE_TAB]} />
              </button>
            )}
            </div>

            <div className="documents-tabs-actions">
              {activeTab === "sent" && HOME_USER_ID && (
                <>
                  {isClient && showClientAddFolder && isRootDocumentsFolder && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="clientaddfolder"
                        iconCls="btn_icon"
                        icon={<img src={AddFolder} alt="Add folder" />}
                        text={addFolderActionText}
                        handleClick={() => openPageAddFolder()}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                  {isClient && showClientUpload && (
                    <UploadFilesHelpTooltip>
                      <div data-tour="upload-files-btn" style={{ display: "inline-block" }}>
                      <Button
                        className="clientupload"
                        variant="outline"
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload Files"
                        handleClick={() => setModalOpen("emp_upload")}
                      />
                      </div>
                    </UploadFilesHelpTooltip>
                  )}
                  {isEmployee && showEmpAddFolder && isRootDocumentsFolder && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="empaddfolder"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={AddFolder} alt="Add folder" />}
                        text={addFolderActionText}
                        handleClick={() => openPageAddFolder()}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                  {isEmployee && showEmpUpload && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="empuploaddoc"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload Files"
                        handleClick={openStaffUploadModal}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                </>
              )}
              {activeTab === "received" && HOME_USER_ID && isEmployee && (
                <>
                  {showStaffReceivedAddFolder && isRootDocumentsFolder && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="empaddfolder"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={AddFolder} alt="Add folder" />}
                        text={addFolderActionText}
                        handleClick={() => openPageAddFolder()}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                  {showStaffReceivedUpload && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="empuploaddoc"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload Files"
                        handleClick={openStaffUploadModal}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                </>
              )}
              {activeTab === "office" && HOME_USER_ID && (
                <>
                      {showOfficeAddFolder && isRootDocumentsFolder && (
                          <div style={{ display: "flex", gap: "12px" }}>
                            <RequestedFilesBlock
                              clientId={HOME_USER_ID}
                              layoutMode={requestedFilesLayoutMode}
                              requestedFileCategory={activeDocCategory}
                              clientBusinessId={selectedClientBusinessId}
                            />
                            <UploadFilesHelpTooltip>
                              <Button
                                variant="outline"
                                className="officeaddfolder"
                                disable={!HOME_USER_ID}
                                iconCls="btn_icon"
                                icon={<img src={AddFolder} alt="Add folder" />}
                                text={addFolderActionText}
                                handleClick={() =>
                                  openPageAddFolder("office_add_folder")
                                }
                              />
                            </UploadFilesHelpTooltip>
                          </div>
                        )}
                  {showOfficeUpload && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="officedoc"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload"
                        handleClick={() => setModalOpen("office_upload")}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                </>
              )}
              {isK1PackageTab && HOME_USER_ID && (
                <>
                  {showK1PackageAddFolder && isRootDocumentsFolder && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="k1packageaddfolder"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={AddFolder} alt="Add folder" />}
                        text={addFolderActionText}
                        handleClick={() => setModalOpen("k1_package_add_folder")}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                  {showK1PackageUpload && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="k1packageupload"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload"
                        handleClick={() => setModalOpen("k1_package_upload")}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                </>
              )}
              {isIndividualFiledCopiesTab && HOME_USER_ID && (
                <>
                  {showIndividualFiledCopiesAddFolder && isRootDocumentsFolder && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="filedcopiesaddfolder"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={AddFolder} alt="Add folder" />}
                        text={addFolderActionText}
                        handleClick={() =>
                          setModalOpen("filed_copies_add_folder")
                        }
                      />
                    </UploadFilesHelpTooltip>
                  )}
                  {showIndividualFiledCopiesUpload && (
                    <UploadFilesHelpTooltip>
                      <Button
                        variant="outline"
                        className="filedcopiesupload"
                        disable={!HOME_USER_ID}
                        iconCls="btn_icon"
                        icon={<img src={FileUpload} alt="File upload" />}
                        text="Upload"
                        handleClick={() => setModalOpen("filed_copies_upload")}
                      />
                    </UploadFilesHelpTooltip>
                  )}
                </>
              )}
              {activeTab === "requested" && isEmployee && (
                <div>
                  <RequestedFilesBlock
                    clientId={HOME_USER_ID}
                    layoutMode={requestedFilesLayoutMode}
                    requestedFileCategory={activeDocCategory}
                    clientBusinessId={selectedClientBusinessId}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Inner frame (breadcrumbs + toolbar + table) */}
          <div className="documents-inner">
            {activeTab === "requested" && isClient && HOME_USER_ID && (
              <RequestedFilesBlock
                clientId={HOME_USER_ID}
                layoutMode={requestedFilesLayoutMode}
                requestedFileCategory={activeDocCategory}
                clientBusinessId={selectedClientBusinessId}
              />
            )}
            {activeTab === DOC_TAB_SENT_FOR_SIGNATURE && HOME_USER_ID && (
              <div className="documents-signature-section">
                <DocuSignSignaturePanel
                  clientId={HOME_USER_ID}
                  documentCategory={activeDocCategory}
                  clientBusinessId={selectedClientBusinessId}
                  readOnly={isClient}
                  refreshKey={signatureRefreshKey}
                  showAdminTools={isAdmin}
                />
              </div>
            )}
            {isDocumentsFolderTab(activeTab) && (
              <>
                <div className="documents-breadcrumb-row">
                  {navPath?.map((item, index) => (
                    <React.Fragment key={`crumb-${index}`}>
                      {index > 0 && (
                        <span className="documents-location-separator">›</span>
                      )}
                      <span
                        className={
                          "documents-location-item" +
                          (index === navPath.length - 1
                            ? " current-folder"
                            : "")
                        }
                        onClick={() =>
                          handleOpen(item.name, item.id, item.created_by, index)
                        }
                      >
                        {index === 0 ? getActiveTabLabel(activeTab) : item.name}
                      </span>
                    </React.Fragment>
                  ))}
                </div>

                {/* Table */}
                <div className="documents-table-wrapper">
                  <table className="documents-table">
                    <thead>
                      <tr>
                        <th style={{ width: "38%" }}>Document</th>
                        <th style={{ width: "14%" }}>Date</th>
                        <th style={{ width: "14%" }}>Created At</th>
                        <th style={{ width: "14%" }}>File Type</th>
                        {showActionColumn && (
                          <th style={{ width: "10%", textAlign: "right" }}>
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {activeTab === "sent" &&
                        renderRowsForType(isClient ? "client" : "emp")}
                      {activeTab === "received" &&
                        renderRowsForType(isClient ? "emp" : "client")}
                      {activeTab === "office" && renderRowsForType("office")}
                      {isK1PackageTab &&
                        renderRowsForType(DOC_TYPE_K1_PACKAGE)}
                      {isIndividualFiledCopiesTab &&
                        renderRowsForType(DOC_TYPE_FILED_COPIES)}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Downloaded section (API-driven: folder.downloaded / file.downloaded) */}
            {isDocumentsFolderTab(activeTab) ? renderDownloadedSection() : null}
          </div>
        </div>
      </div>

      {/* Upload / add folder modal */}
      {isModalOpen && (
        <Modal
          className={`timesheet-view-modal ${
            isModalOpen.includes("upload") ? "upload-files-modal" : ""
          } ${
            isModalOpen.includes("add_folder") &&
            !isModalOpen.includes("upload")
              ? "add-folder-modal"
              : ""
          }`}
          open={isModalOpen}
          handleClose={handleCloseModal}
          maxWidth={false}
          // className={isModalOpen.includes("upload") ? "upload-files-modal" : ""}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div>
              <h3 style={{ fontWeight: "bold", fontSize: "24px" }}>
                {isModalOpen.includes("upload")
                  ? "Upload Files"
                  : isModalOpen === "preview"
                  ? "Preview"
                  : folderModalHeading}
              </h3>
              {modalBreadcrumbPath.length > 0 && (
                <div
                  style={{
                    color: "#6b7280",
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginTop: "4px",
                  }}
                >
                  {modalBreadcrumbPath.map((part, index) => (
                    <React.Fragment key={`modal-breadcrumb-${index}`}>
                      {index > 0 && <span> &gt; </span>}
                      <span>{part.name}</span>
                    </React.Fragment>
                  ))}
                </div>
              )}
              {isModalOpen.includes("upload") && showUploadSubFolderInput && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="text"
                    value={uploadSubFolderName}
                    onChange={(e) => setUploadSubFolderName(e.target.value)}
                    placeholder="Enter sub folder name"
                    style={{
                      minWidth: "260px",
                      height: "40px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "0 12px",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  <button
                    className="upload-button"
                    onClick={addUploadSubFolder}
                  >
                    Add
                  </button>
                  <button
                    className="upload-button"
                    onClick={cancelUploadSubFolderInput}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <button className="close-btn" onClick={handleCloseModal}>
              ✕
            </button>
          </div>
          <div className="add_folder_modal">
            {isModalOpen.includes("upload") ? (
              <>
                <div className="upload-modal">
                  <div
                    className="drop-area-main"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <p className="drop-text">Drag & Drop file here, or</p>
                    <p className="upload-file-note">{DOCUMENT_UPLOAD_SIZE_NOTE}</p>
                    <label className="file-input-label">
                      <input
                        type="file"
                        multiple
                        accept={DOCUMENT_UPLOAD_ACCEPT}
                        onChange={handleFileChange}
                        hidden
                      />
                      <span className="add-files-button">Add Files</span>
                    </label>
                  </div>

                  {showFiledCopiesTagPicker ? (
                      <FiledCopiesUploadFileList
                        files={selectedFiles}
                        tags={filedCopiesFileTags}
                        documentCategory={activeDocCategory}
                        serviceOptions={filedCopiesServiceOptions}
                        selectedServiceId={filedCopiesSelectedServiceId}
                        onServiceChange={setFiledCopiesSelectedServiceId}
                        onTagChange={handleFiledCopiesTagChange}
                        onRemoveFile={handleRemoveFile}
                      />
                    ) : selectedFiles.length > 0 ? (
                    <div className="individual-file-fields">
                      {selectedFiles.map((file, index) => (
                        <div key={index} className="individual-file-field">
                          <div className="file-field-content">
                            <span className="file-name-text">{file.name}</span>
                            <button
                              className="remove-file-icon"
                              onClick={() => handleRemoveFile(index)}
                              aria-label="Remove file"
                            >
                              ✖
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    ) : null}

                  {/* Footer with Toggle and Upload Button */}
                  <div className="upload-modal-footer">
                    <div className="email-switch">
                      <EmailNotificationSwitch
                            checked={sendNotifications}
                        onChange={handleEmailNotificationChange}
                      />
                    </div>
                    <div className="upload-modal-actions">
                      {(modalBreadcrumbPath.length > 1) &&
                        !showUploadSubFolderInput && (
                          <button
                            className="upload-button"
                            onClick={openUploadSubFolderInput}
                          >
                            Add Sub Folder
                          </button>
                        )}
                      <button
                        className="upload-button"
                        onClick={() =>
                          modelAction({
                            fileData,
                            newFolderName,
                            sendNotifications,
                            notificationLevel,
                          })
                        }
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) :   (
              <>
                <div
                  style={{
                    width: "100%",
                    marginTop: "7px",
                    marginBottom: "16px",
                  }}
                >
                  {folderModalStage === "root" &&
                  navPath.length === 1 &&
                  navPath[0]?.id === 0 ? (
                    <Labelbox
                      type="select"
                      labelname="Folder Name"
                      dropdown={rootUploadFolderOptions}
                      changeData={(data) => setNewFolderName(data)}
                      value={newFolderName}
                    />
                  ) : folderModalStage === "inner" ? (
                    <Labelbox
                      type="text"
                      labelname="Folder Name"
                      changeData={(data) =>
                        setNewFolderName(data.replace(/[^\w ]/g, ""))
                      }
                      value={newFolderName}
                      placeholder="Enter name"
                    />
                  ) : null}
                </div>
                <div className="modal-actions-right">
                  {folderModalStage === "root" &&
                    navPath.length === 1 &&
                    navPath[0]?.id === 0 && (
                      <>
                        {!folderExists && (
                          <button
                            className="upload-button"
                            onClick={handleCreateFolderDirectly}
                          >
                            Add
                          </button>
                        )}
                        <button
                          className="upload-button"
                          style={{ marginLeft: folderExists ? "0px" : "8px" }}
                          onClick={() => modelAction()}
                        >
                          Upload Files
                        </button>
                      </>
                    )}

                  {folderModalStage === "menu" && (
                    <>
                      <button
                        className="upload-button"
                        onClick={openInnerFolderModal}
                      >
                        Add Sub Folder
                      </button>
                      <button
                        className="upload-button"
                        style={{ marginLeft: "8px" }}
                        onClick={openFolderModalUpload}
                      >
                        Upload Files
                      </button>
                    </>
                  )}

                  {folderModalStage === "inner" && (
                    <button
                      className="upload-button"
                      onClick={() => modelAction()}
                    >
                      Add
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </Modal>
      )}

      <MultiDocumentPreviewDock
        previews={documentPreviews}
        onRemove={removeDocumentPreview}
        onCloseAll={closeAllDocumentPreviews}
      />

      {/* Delete file confirmation modal */}
      <div className="delete-file-modal">
        {" "}
        {deleteDialog.open && (
          <Modal
            title={null}
            open={deleteDialog.open}
            handleClose={closeDeleteDialog}
            className="delete-confirm-modal timesheet-view-modal"
          >
            <div className="delete-confirm">
              <div className="delete-confirm-header">
                <h3>Delete</h3>
                <button
                  type="button"
                  className="delete-confirm-close"
                  onClick={closeDeleteDialog}
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>
              <p className="delete-confirm-text">
                Are you sure want delete this file?
              </p>
              <div className="delete-confirm-actions">
                <button
                  type="button"
                  className="delete-btn secondary"
                  onClick={closeDeleteDialog}
                >
                  No
                </button>
                <button
                  type="button"
                  className="delete-btn danger"
                  onClick={confirmDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>

      {/* Delete folder confirmation modal */}
      {deleteFolderDialog.open && (
        <Modal
          title={null}
          open={deleteFolderDialog.open}
          handleClose={closeDeleteFolderDialog}
          className="delete-confirm-modal timesheet-view-modal"
        >
          <div className="delete-confirm">
            <div className="delete-confirm-header">
              <h3>Delete</h3>
              <button
                type="button"
                className="delete-confirm-close"
                onClick={closeDeleteFolderDialog}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <p className="delete-confirm-text">
              Are you sure want delete this folder?
            </p>
            <div className="delete-confirm-actions">
              <button
                type="button"
                className="delete-btn secondary"
                onClick={closeDeleteFolderDialog}
              >
                No
              </button>
              <button
                type="button"
                className="delete-btn danger"
                onClick={confirmDeleteFolder}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Rename file dialog */}
      <Dialog
        open={renameModalOpen}
        onClose={() => setRenameModalOpen(false)}
        classes={{ paper: "rename-modal-paper" }}
      >
        <div className="rename-modal">
          <div className="rename-modal-header">
            <h2 className="rename-modal-title">
              {selectedFile !== null
                ? `Rename ${selectedFile.document_name}`
                : "Rename File"}
            </h2>
            <button
              type="button"
              className="rename-modal-close"
              onClick={() => setRenameModalOpen(false)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
          <TextField
            label="New Name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
          />
          <div className="modal-actions-right">
            <button
              className="primary-action-btn"
              onClick={() => handleRename(selectedFile, newName)}
            >
              Rename
            </button>
          </div>
        </div>
      </Dialog>

      {/* Move file/folder modal */}
      <MoveItemModal
        open={moveModalOpen}
        onClose={closeMoveModal}
        item={moveItem}
        userId={HOME_USER_ID}
        homeFolder={HOME_FOLDER}
        clientBusinessId={
          activeDocCategory === "business" ? selectedClientBusinessId : null
        }
        lockBusinessCategory={activeDocCategory === "business"}
        initialDocumentCategory={activeDocCategory}
        initialPurposeTab={
          isFiledCopiesTab
            ? activeTab
            : activeTab === "office"
              ? "office"
              : activeTab === "received"
                ? "received"
                : activeTab === "sent"
                  ? "sent"
                  : "received"
        }
        showBusinessTab={isBusinessClient}
        currentFolderId={
          moveItem?.type === "folder"
            ? (moveItem?.data?.parent_folder_id ?? null)
            : (moveItem?.data?.client_folder_id ?? null)
        }
        onConfirm={handleMoveConfirm}
      />

      {/* Rename folder dialog */}
      <Dialog
        open={renameFolderModalOpen}
        onClose={() => setRenameFolderModalOpen(false)}
        classes={{ paper: "rename-modal-paper" }}
      >
        <div className="rename-modal">
          <div className="rename-modal-header">
            <h2 className="rename-modal-title">
              Rename {selectedFolder ? selectedFolder.folder_name : "Folder"}
            </h2>
            <button
              type="button"
              className="rename-modal-close"
              onClick={() => setRenameFolderModalOpen(false)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
          <TextField
            label="New Name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
          />
          <div className="modal-actions-right">
            <button
              className="primary-action-btn"
              onClick={() => handleRenameFolder(selectedFolder, newName)}
            >
              Rename
            </button>
          </div>
        </div>
      </Dialog>

      <DocuSignSendModal
        open={signatureModal.open}
        onClose={() => setSignatureModal({ open: false, document: null })}
        document={signatureModal.document}
        clientId={HOME_USER_ID}
        documentCategory={docCategoryQueryValue || null}
        defaultSigner={defaultSignatureSigner}
        onSuccess={() => {
          setSignatureModal({ open: false, document: null });
          setSignatureRefreshKey((value) => value + 1);
          if (activeTab !== DOC_TAB_SENT_FOR_SIGNATURE) {
            handleDocumentTabChange(DOC_TAB_SENT_FOR_SIGNATURE);
          }
        }}
      />
    </>
  );
};

export default UploadDoc;

//when employee added a file mail doesn't sent to client but when folder is added mail sent to client
